// Norwegian (Bokmål) — the canonical translation dictionary. Its keys define
// the TranslationKey union; every other language is type-checked against it for
// completeness (see ./en.ts). Add new UI strings here first.
export const nb = {
  'nav.home': 'Hjem',
  'nav.about': 'Om',
  'nav.toggle': 'Veksle navigasjon',
  'nav.beamDesigner.locked': 'Logg inn for å bruke Bjelkedesigner',
  'nav.signInPrompt': 'Logg inn for å få tilgang til denne funksjonen.',

  'app.wood.beamLabel': 'Trebjelke-design',
  'app.concrete.beamLabel': 'Betongbjelke-design',
  'app.steel.beamLabel': 'Stålbjelke-design',

  'lang.label': 'Språk',
  'lang.norwegian': 'Norsk',
  'lang.english': 'Engelsk',

  // ===== Beam designer — workspace chrome =====
  'beam.tab.geometry': 'Geometri',
  'beam.tab.materials': 'Materialer',
  'beam.tab.loads': 'Laster',
  'beam.tab.results': 'Analyse',
  'beam.tab.response': 'Resultater',
  'beam.tab.report': 'Rapport',
  'beam.results.deflectionNoCreepNoteTimber': 'Nedbøyningene i denne fanen er elastiske momentannedbøyninger (w_inst) uten kryp. Endelig nedbøyning w_fin = w_inst + k_def·w_qp etter NS-EN 1995-1-1 §2.2.3 (k_def fra klimaklasse, w_qp fra tilnærmet permanent kombinasjon) vises i Resultater-fanen.',
  'beam.results.deflectionNoCreepNoteConcrete': 'Nedbøyningene i denne fanen er elastiske for uopprisset tverrsnitt med E_cm, uten kryp og opprissing. Momentan nedbøyning w_inst (opprisset, ζ-metoden) og endelig nedbøyning w_fin med kryp (E_c,eff = E_cm/(1+φ)) etter NS-EN 1992-1-1 §7.4.3 vises i Resultater-fanen.',
  'beam.tab.ariaLabel': '{title}-fane',

  'beam.header.geometry': 'Bjelkegeometri',
  'beam.header.materials': 'Materialegenskaper',
  'beam.header.loads': 'Lastpåføring',
  'beam.header.response': 'Respons og utnyttelse',
  'beam.header.report': 'Dimensjoneringsrapport',
  'beam.header.results': 'Analyseresultater',

  'beam.timberType.label': 'Tretype:',
  'beam.timberType.selection': 'Valg av tretype',
  'beam.timberType.solid': 'Heltre',
  'beam.timberType.glulam': 'Limtre',

  'beam.status.loading': 'Laster …',
  'beam.status.analysisRunning': 'Analyse pågår',
  'beam.status.analyzingModel': 'Analyserer bjelkemodell …',

  // ===== Beam designer — geometry tab =====
  'beam.geometry.dismissNotice': 'Lukk melding',
  'beam.geometry.beamSpans': 'Bjelkefelt ({count})',
  'beam.geometry.addSpan': 'Legg til felt',
  'beam.geometry.currentSpans': 'Gjeldende felt',
  'beam.geometry.spanNumber': 'Felt {n}',
  'beam.geometry.spanMeta': 'Node {left} → Node {right} | E: {e} GPa | A: {a} cm² | I: {i} cm⁴',
  'beam.geometry.loadsApplied': '{count} last(er) påført',
  'beam.geometry.removeSpan': 'Fjern felt',
  'beam.geometry.supportConditions': 'Opplagerbetingelser',
  'beam.geometry.node': 'Node {id}:',
  'beam.geometry.bearingLength': 'Opplegglengde (mm)',
  'beam.geometry.bearingLengthHint': 'Kontaktlengde ved opplegget — aktiverer kontroll av trykk vinkelrett på fiberretningen (EC5 §6.1.5)',
  'beam.support.fixed': 'Innspent',
  'beam.support.pinned': 'Fastlager',
  'beam.support.roller': 'Rullelager',
  'beam.support.free': 'Fri',
  'beam.geometry.crossSection': 'Tverrsnitt',
  'beam.geometry.loadingCatalog': 'Laster katalog fra server …',
  'beam.geometry.catalogError': '{error}. Bruker innebygde presett.',
  'beam.geometry.selectPresetPlaceholder': 'Velg standardtverrsnitt …',
  'beam.geometry.custom': 'Egendefinert',
  'beam.geometry.customSectionHint': 'Egendefinert tverrsnitt: Skriv inn mål manuelt. Areal og treghetsmoment beregnes for rektangulære tverrsnitt.',
  'beam.geometry.width': 'Bredde (mm):',
  'beam.geometry.height': 'Høyde (mm):',
  'beam.geometry.webThickness': 'Stegtykkelse (mm):',
  'beam.geometry.flangeThickness': 'Flenstykkelse (mm):',
  'beam.geometry.optionalIH': '(valgfritt, for I/H-bjelker)',
  'beam.geometry.egExample6': 'f.eks. 6.0',
  'beam.geometry.egExample10': 'f.eks. 10.0',
  'beam.geometry.webFlangeHint': 'Steg- og flenstykkelse brukes til tverrsnittsklassifisering (EN 1993-1-1) og kontroll av lokal knekking.',
  'beam.geometry.calculatedProps': 'Beregnede egenskaper (rektangulær):',
  'beam.geometry.areaValue': 'Areal: {cm2} cm² ({mm2} mm²)',
  'beam.geometry.inertiaValue': 'Treghetsmoment: {cm4} cm⁴ ({mm4} mm⁴)',
  'beam.geometry.backToStandard': 'Tilbake til standardtverrsnitt',
  'beam.geometry.sectionClassTitle': 'Tverrsnittsklasse (EN 1993-1-1)',
  'beam.geometry.sectionClassHelp': 'Styrer beregning av plastisk/elastisk kapasitet. «Auto» beregner ut fra geometri og flytegrense.',
  'beam.geometry.classAuto': 'Auto (beregn fra geometri)',
  'beam.geometry.class1': 'Klasse 1 – Plastisk (full plastisk momentkapasitet)',
  'beam.geometry.class2': 'Klasse 2 – Kompakt (plastisk moment, uten rotasjonskapasitet)',
  'beam.geometry.class3': 'Klasse 3 – Halvkompakt (elastisk momentkapasitet)',
  'beam.geometry.class4': 'Klasse 4 – Slank (effektivt tverrsnitt kreves)',
  'beam.geometry.classAutoNote': 'Tverrsnittsklasse beregnes automatisk ut fra bredde/tykkelse-forhold og stålkvalitet.',
  'beam.geometry.classOverrideNote': 'Overstyrer automatisk beregning. Bruker klasse {n} for alle kontroller.',
  'beam.geometry.spanLengths': 'Feltlengder (m)',
  'beam.geometry.lengthChangeHint': 'Endring av lengde vil justere/fjerne laster',
  'beam.geometry.loadingCrossSection': 'Laster tverrsnitt …',
  'beam.geometry.reinforcement': 'Armering',
  'beam.geometry.rebarZones': 'Armeringssoner (langs bjelken)',
  'beam.geometry.rebarZonesHint': 'z=0 i tverrsnittets senter; z positiv mot toppen. Overdekning (cnom) måles til ytterste armering (bøyler) iht. EC2 4.4.1. z-posisjoner beregnes automatisk fra overdekning, bøyle-Ø og stang-Ø.',
  'beam.geometry.addZone': 'Legg til sone',
  'beam.geometry.zoneStart': 'Start (m)',
  'beam.geometry.zoneEnd': 'Slutt (m)',
  'beam.geometry.zoneCover': 'Overdekning (mm)',
  'beam.geometry.removeZone': 'Fjern sone',
  'beam.geometry.addRebarBottom': 'Legg til armering i bunn',
  'beam.geometry.addRebarTop': 'Legg til armering i topp',
  'beam.geometry.addStirrups': 'Legg til bøyler',
  'beam.geometry.layerZ': 'z (mm)',
  'beam.geometry.layerDiameter': 'Ø (mm)',
  'beam.geometry.layerCount': 'Antall',
  'beam.geometry.remove': 'Fjern',
  'beam.geometry.stirrupDiameter': 'Bøyle-Ø (mm)',
  'beam.geometry.stirrupSpacing': 'Senteravstand (mm)',
  'beam.geometry.stirrupLegs': 'Snitt',
  'beam.geometry.removeStirrups': 'Fjern bøyler',

  // ===== Beam designer — shared labels =====
  'beam.common.beamModel': 'Bjelkemodell',

  // ===== Beam designer — materials tab =====
  'beam.materials.nationalAnnex': 'Nasjonalt tillegg / dimensjoneringsregler',
  'beam.materials.annexNorwegian': '🇳🇴 Norsk (NS-EN) – standard',
  'beam.materials.annexStandard': '🇪🇺 Standard Eurokode',
  'beam.materials.labelSteel': 'Stål',
  'beam.materials.labelConcrete': 'Betong',
  'beam.materials.labelGlulam': 'Limtre',
  'beam.materials.labelSolidWood': 'Heltre',
  'beam.materials.labelUnknown': 'Ukjent',
  'beam.materials.selectedMaterial': 'Valgt materiale',
  'beam.materials.changeHint': 'Bytt materiale med velgeren over fanene',
  'beam.materials.classOrGrade': 'Materialklasse / kvalitet',
  'beam.materials.steelGrade': 'Stålkvalitet',
  'beam.materials.subgrade': 'Underkvalitet',
  'beam.materials.thicknessLe': 'Tykkelse ≤ (mm)',
  'beam.materials.concrete': 'Betong',
  'beam.materials.reinforcement': 'Armering',
  'beam.materials.reinfNorwegian': 'Norsk (NS 3576-3)',
  'beam.materials.reinfEurocode': 'Eurokode (EN 10080)',
  'beam.materials.b500nc': 'B500NC (duktilitet C)',
  'beam.materials.b500nb': 'B500NB (duktilitet B)',
  'beam.materials.b500c': 'B500C (duktilitet C)',
  'beam.materials.b500b': 'B500B (duktilitet B)',
  'beam.materials.b500a': 'B500A (duktilitet A)',
  'beam.materials.prestressingPT': 'Spennarmering (PT)',
  'beam.materials.creepShrinkageParams': 'Kryp- og svinnparametere (EN 1992-1-1 Tillegg B)',
  'beam.materials.relativeHumidity': 'Relativ fuktighet (%)',
  'beam.materials.rh40': '40 % (tørt innendørs)',
  'beam.materials.rh50': '50 % (normalt innendørs)',
  'beam.materials.rh60': '60 % (fuktig innendørs)',
  'beam.materials.rh70': '70 % (skjermet utendørs)',
  'beam.materials.rh80': '80 % (eksponert utendørs)',
  'beam.materials.rh90': '90 % (svært fuktig)',
  'beam.materials.notionalSize': 'Effektiv tverrsnittstykkelse h₀ (mm)',
  'beam.materials.loadingAge': 'Belastningsalder t₀ (døgn)',
  'beam.materials.age7': '7 døgn (tidlig)',
  'beam.materials.age14': '14 døgn',
  'beam.materials.age28': '28 døgn (standard)',
  'beam.materials.age56': '56 døgn',
  'beam.materials.age90': '90 døgn',
  'beam.materials.age365': '1 år',
  'beam.materials.cementType': 'Sementtype',
  'beam.materials.cementS': 'S (langsom)',
  'beam.materials.cementN': 'N (normal)',
  'beam.materials.cementR': 'R (rask)',
  'beam.materials.forShrinkage': 'For svinn',
  'beam.materials.creepCoefficient': 'Krypkoeffisient φ(∞,t₀):',
  'beam.materials.ecEffNote': 'Ec,eff = Ecm / (1 + φ) for langtids nedbøyningsanalyse',
  'beam.materials.timberClass': 'Trekvalitet',
  'beam.materials.kmodLoadDuration': 'Lastvarighetsklasse for nyttelast',
  'beam.materials.kmodDerivedNote': 'kmod per kombinasjon utledes fra lasten med kortest varighet (EC5 §3.1.3). Dette valget angir varighetsklassen for nyttelast; egenvekt/snø/vind følger tabell NA.2.2.',
  'beam.materials.durationPermanent': 'Permanent ({k})',
  'beam.materials.durationLong': 'Langtids ({k})',
  'beam.materials.durationMedium': 'Middels lang ({k})',
  'beam.materials.durationShort': 'Korttids ({k})',
  'beam.materials.durationInstant': 'Øyeblikkelig ({k})',
  'beam.materials.kmodValue': 'kmod = {k}',
  'beam.materials.serviceClass': 'Klimaklasse',
  'beam.materials.serviceClass1': 'Klasse 1 (tørr, <12 % fukt)',
  'beam.materials.serviceClass2': 'Klasse 2 (beskyttet, <20 % fukt)',
  'beam.materials.serviceClass3': 'Klasse 3 (utendørs, >20 % fukt)',
  'beam.materials.creepFactorKdef': 'Krypfaktor kdef:',
  'beam.materials.ec5Table32': '(EN 1995-1-1 Tabell 3.2)',
  'beam.materials.finalDeflection': 'Endelig nedbøyning: u_fin = u_inst · (1 + k_def) = u_inst · {factor}',
  'beam.materials.showDetails': 'Vis detaljer for valgt materiale',
  'beam.materials.materialProperties': 'Materialegenskaper',
  'beam.materials.loadingShort': '(Laster …)',
  'beam.materials.loadingFromDb': 'Laster materialegenskaper fra database …',
  'beam.materials.standard': 'Standard:',
  'beam.materials.material': 'Materiale',
  'beam.materials.properties': 'Egenskaper',
  'beam.materials.strengths': 'Fastheter',
  'beam.materials.grade': 'Kvalitet:',
  'beam.materials.productForm': 'Produktform:',
  'beam.materials.thicknessRange': 'Tykkelsesområde:',
  'beam.materials.yieldStrength': 'Flytegrense (fy):',
  'beam.materials.designStrengthFyd': 'Dimensjonerende fasthet (fyd):',
  'beam.materials.ultimateStrengthFu': 'Bruddfasthet (fu):',
  'beam.materials.elasticModulusE': 'Elastisitetsmodul (E):',
  'beam.materials.density': 'Densitet:',
  'beam.materials.type': 'Type:',
  'beam.materials.solidTimber': 'Heltre',
  'beam.materials.gluedLaminated': 'Limtre',
  'beam.materials.class': 'Klasse:',
  'beam.materials.bendingFbd': 'Bøyning (fb,d):',
  'beam.materials.tensionFt0d': 'Strekk ∥ (ft,0,d):',
  'beam.materials.compressionFc0d': 'Trykk ∥ (fc,0,d):',
  'beam.materials.shearFvd': 'Skjær (fv,d):',
  'beam.materials.eModulusE0': 'E-modul (E0,mean):',
  'beam.materials.characteristicFck': 'Karakteristisk (fck):',
  'beam.materials.designCompressiveFcd': 'Dim. trykkfasthet (fcd):',
  'beam.materials.designTensileFctd': 'Dim. strekkfasthet (fctd):',
  'beam.materials.elasticModulusEcm': 'Elastisitetsmodul (Ecm):',
  'beam.materials.ultimateStrainEcu3': 'Bruddtøyning (εcu3):',
  'beam.materials.strainAtPeakEc3': 'Tøyning ved topp (εc3):',
  'beam.materials.reinforcementSteel': 'Armeringsstål',
  'beam.materials.ductilityClass': 'Duktilitetsklasse:',
  'beam.materials.characteristicFyk': 'Karakteristisk (fyk):',
  'beam.materials.tensileStrengthFtk': 'Strekkfasthet (ftk):',
  'beam.materials.ratioKFtkFyk': 'Forhold (k = ftk/fyk):',
  'beam.materials.yieldStrainEyd': 'Flytetøyning (εyd):',
  'beam.materials.strainAtMaxEuk': 'Tøyning ved maks (εuk):',
  'beam.materials.prestressingSteel': 'Spennstål',
  'beam.materials.tensileStrengthFpk': 'Strekkfasthet (fpk):',
  'beam.materials.designStrengthFpd': 'Dimensjonerende fasthet (fpd):',
  'beam.materials.proof01Fp01k': '0,1 %-grense (fp0.1k):',
  'beam.materials.ratioKFpkFp01k': 'Forhold (k = fpk/fp0.1k):',
  'beam.materials.elasticStrainEp01k': 'Elastisk tøyning (εp0.1k):',
  'beam.materials.strainAtFpkEpk': 'Tøyning ved fpk (εpk):',
  'beam.materials.ultimateStrainEuk': 'Bruddtøyning (εuk):',
  'beam.materials.relaxationClass': 'Relaksasjonsklasse:',
  'beam.materials.selfWeight': 'Egenvekt',
  'beam.materials.currentSelfWeight': 'Gjeldende egenvektlast:',
  'beam.materials.selfWeightCalc': 'Beregnet fra: {density} kg/m³ × {area} cm² × 9.81 m/s²',
  'beam.materials.partialFactors': 'Eurokode materialpartialfaktorer (γM)',
  'beam.materials.checkLtb': 'Kontroller vipping (lateral knekking)',
  'beam.materials.checkLtbHint': 'Fjern haken når konstruksjonen sideveis fastholder trykkflensen (f.eks. fast dekke) slik at vipping ikke kan oppstå — χLT / kcrit settes da til 1,0.',
  'beam.materials.reliabilityClass': 'Pålitelighetsklasse',
  'beam.materials.reliabilityClass1': 'RC1 — liten konsekvens (KFI = 0,9 på variable laster)',
  'beam.materials.reliabilityClass2': 'RC2 — normal (KFI = 1,0)',
  'beam.materials.reliabilityClass3': 'RC3 — stor konsekvens (ingen lastfaktorøkning i NA)',
  'beam.materials.applyRc1Reduction': 'Anvend KFI = 0,9 på variable laster',
  'beam.materials.applyRc1ReductionHint': 'NA-en tillater reduksjonen ("γF kan reduseres"), den er ikke påbudt. Slå av for å beholde γQ = 1,5 i RC1.',
  'beam.materials.ulsSteel': 'ULS (bruddgrensetilstand) – EN 1993-1-1:',
  'beam.materials.ulsConcrete': 'ULS (bruddgrensetilstand) – EN 1992-1-1:',
  'beam.materials.ulsTimber': 'ULS (bruddgrensetilstand) – EN 1995-1-1:',
  'beam.materials.sls': 'SLS (bruksgrensetilstand):',
  'beam.materials.als': 'ALS (ulykkesgrensetilstand):',
  'beam.materials.noteCrossSectionResistance': '(tverrsnittskapasitet)',
  'beam.materials.noteInstabilityResistance': '(kapasitet mot instabilitet)',
  'beam.materials.noteTensionConnections': '(kapasitet for strekkforbindelser)',
  'beam.materials.noteSteelFactorsSame': 'Merk: Stålets materialfaktorer er like for norsk og standard Eurokode.',
  'beam.materials.noteConcrete': '(betong)',
  'beam.materials.noteReinfSteel': '(armeringsstål)',
  'beam.materials.notePrestressSteel': '(spennstål/etteroppspenning)',
  'beam.materials.noteAlphaCC': '(koeffisient for langtids betongfasthet)',
  'beam.materials.noteConcreteReduced': '(betong – redusert)',
  'beam.materials.referenceProps': 'Referanseegenskaper:',
  'beam.materials.refReinforcement': 'Armering (B500NC): fy = {fy} MPa, Es = {es} GPa',
  'beam.materials.refPrestressing': 'Spennarmering (Y1860): fpk = {fpk} MPa, Ep = {ep} GPa',
  'beam.materials.noteGlulam': '(limtre)',
  'beam.materials.noteSolidSawn': '(heltre/skåret tre)',
  'beam.materials.noteFromDurationService': '(fra lastvarighet og klimaklasse)',
  'beam.materials.timberDesignStrengthNote': 'Dimensjonerende fasthet: f_d = k_mod × f_k / γ_M. Limtre har lavere γM enn heltre på grunn av bedre materialkvalitet.',
  'beam.materials.manualProperties': 'Manuelle egenskaper',
  'beam.materials.youngsModulus': 'E-modul (GPa):',
  'beam.materials.notesSteel': 'Stålets materialfaktorer (γM0, γM1, γM2) er like for norsk og standard Eurokode.',
  'beam.materials.notesConcreteAlphaCC': 'αcc (koeffisient for langtids betongfasthet):',
  'beam.materials.notesConcreteNorwegian': 'Norsk NS-EN: 0,85 (15 % reduksjon)',
  'beam.materials.notesConcreteStandard': 'Standard Eurokode: 1,00 (ingen reduksjon)',
  'beam.materials.notesConcreteOther': 'Øvrige faktorer (γC, γS, γP) er like for begge.',
  'beam.materials.notesTimber': 'Treets materialfaktorer (γM) avhenger av nasjonalt tillegg. Norsk NS-EN: limtre 1,15, heltre 1,25. Standard Eurokode: limtre 1,25, heltre 1,30.',

  // ===== Beam designer — loads tab =====
  'beam.loads.selectSpan': 'Velg felt',
  'beam.loads.imposedLoadCategory': 'Nyttelastkategori (NS-EN 1991-1-1)',
  'beam.loads.imposedLoadCategoryHint': 'Velger ψ₀/ψ₁/ψ₂-faktorene for nyttelast etter NS-EN 1990 tabell NA.A1.1 (hentes fra kodedatabasen).',
  'beam.loads.imposedLoadCategoryA': 'A — Boliger',
  'beam.loads.imposedLoadCategoryB': 'B — Kontorer',
  'beam.loads.imposedLoadCategoryC': 'C — Forsamlingslokaler, møterom',
  'beam.loads.imposedLoadCategoryD': 'D — Butikker',
  'beam.loads.imposedLoadCategoryE': 'E — Lager',
  'beam.loads.imposedLoadCategoryF': 'F — Trafikk-/parkeringsarealer, kjøretøy ≤ 30 kN',
  'beam.loads.imposedLoadCategoryG': 'G — Trafikk-/parkeringsarealer, kjøretøy 30–160 kN',
  'beam.loads.imposedLoadCategoryH': 'H — Tak',
  'beam.loads.allSpans': 'Alle felt',
  'beam.loads.spanOption': 'Felt {id} ({length}m)',
  'beam.loads.loadType': 'Lasttype',
  'beam.loads.typeSelfWeight': 'Egenvekt (auto, kN/m)',
  'beam.loads.typeUniform': 'Jevnt fordelt last (kN/m)',
  'beam.loads.typePoint': 'Punktlast (kN)',
  'beam.loads.typeTriRight': 'Trekantlast (min → maks) (kN/m)',
  'beam.loads.typeTriLeft': 'Trekantlast (maks → min) (kN/m)',
  'beam.loads.typeAxial': 'Aksialkraft (ved feltende, kN)',
  'beam.loads.loadCategory': 'Lastkategori',
  'beam.loads.catPermanent': 'Permanent (G)',
  'beam.loads.catVariable': 'Variabel (Q)',
  'beam.loads.catSnow': 'Snø (Qs)',
  'beam.loads.catWind': 'Vind (Qw)',
  'beam.loads.badgePermanent': 'Permanent',
  'beam.loads.badgeVariable': 'Variabel',
  'beam.loads.badgeSnow': 'Snø',
  'beam.loads.badgeWind': 'Vind',
  'beam.loads.badgePrestress': 'Spennkraft',
  'beam.loads.shortUniform': 'Jevnt fordelt last',
  'beam.loads.shortPoint': 'Punktlast',
  'beam.loads.shortTriRight': 'Trekantlast (min → maks)',
  'beam.loads.shortTriLeft': 'Trekantlast (maks → min)',
  'beam.loads.shortAxial': 'Aksialkraft',
  'beam.loads.dirDown': '(nedover)',
  'beam.loads.dirUp': '(oppover)',
  'beam.loads.dirUpDown': '(oppover og nedover)',
  'beam.loads.tension': '(strekk)',
  'beam.loads.compression': '(trykk)',
  'beam.loads.endLeft': 'venstre',
  'beam.loads.endRight': 'høyre',
  'beam.loads.uniformDesc': '{intensity} kN/m {dir}',
  'beam.loads.pointDesc': '{load} kN @ {pos}m {dir}',
  'beam.loads.triangularDesc': '{start} → {end} kN/m ({startPos}m til {endPos}m) {dir}',
  'beam.loads.axialDesc': '{force} kN ved {end}-ende {dir}{ecc}',
  'beam.loads.axialEcc': ', e = {e} m (M = {m} kNm)',
  'beam.loads.noLoads': 'Ingen laster påført dette feltet',
  'beam.loads.selfWeightAutoTitle': 'Egenvekt (automatisk)',
  'beam.loads.selfWeightUpdates': 'Oppdateres automatisk ved endring av materiale/tverrsnitt',
  'beam.loads.editLoad': 'Rediger last',
  'beam.loads.removeSelfWeight': 'Fjern egenvektlast',
  'beam.loads.removeLoad': 'Fjern last',
  'beam.loads.appliedLoads': 'Påførte laster på felt {span}',
  'beam.loads.appliedLoadsAll': 'Påførte laster (alle felt)',
  'beam.loads.selfWeightFull': 'Egenvekt (kN/m, auto fra materiale/tverrsnitt)',
  'beam.loads.loadValueKnm': 'Lastverdi (kN/m)',
  'beam.loads.loadValueKn': 'Lastverdi (kN):',
  'beam.loads.position': 'Posisjon (m):',
  'beam.loads.minValue': 'Min.verdi',
  'beam.loads.maxValue': 'Maks.verdi',
  'beam.loads.startPosition': 'Startposisjon (m):',
  'beam.loads.endPosition': 'Sluttposisjon (m):',
  'beam.loads.forceValue': 'Kraftverdi (kN):',
  'beam.loads.posTensionNegCompression': 'Positiv = strekk, negativ = trykk',
  'beam.loads.eccentricity': 'Eksentrisitet (m):',
  'beam.loads.eccentricityHint': 'Avstand fra tyngdepunkt (gir moment M = N × e)',
  'beam.loads.applyAt': 'Påfør ved:',
  'beam.loads.leftEnd': 'Venstre ende',
  'beam.loads.rightEnd': 'Høyre ende',
  'beam.loads.saveChanges': 'Lagre endringer',
  'beam.loads.addLoad': 'Legg til last',
  'beam.loads.cancel': 'Avbryt',
  'beam.loads.beamWithLoads': 'Bjelke med laster',

  // ----- PT cables (concrete only) -----
  'beam.pt.sectionAria': 'Spennkabler – etteroppspenning',
  'beam.pt.title': 'Spennkabler (etteroppspenning)',
  'beam.pt.materialNotLoaded': 'Materialegenskaper er ikke fullt lastet. Tapsberegninger kan være ufullstendige.',
  'beam.pt.intro': 'Definer spennkabler ut fra antall liner og spenningsnivå. Tap beregnes iht. EC2 5.10.',
  'beam.pt.appliedCables': 'Påførte spennkabler',
  'beam.pt.removeCable': 'Fjern kabel',
  'beam.pt.addCable': 'Legg til spennkabel',
  'beam.pt.strandType': 'Linetype',
  'beam.pt.numberOfStrands': 'Antall liner',
  'beam.pt.strandArea': 'Lineareal (mm²)',
  'beam.pt.totalArea': 'Totalt: {area} mm²',
  'beam.pt.initialStressLevel': 'Initielt spenningsnivå (%)',
  'beam.pt.percentOfMax': '% av maks ({max} MPa)',
  'beam.pt.initialStress': 'Initiell spenning σp0',
  'beam.pt.ec2Limit': 'Grense EC2 5.10.3',
  'beam.pt.initialForce': 'Initiell kraft P₀',
  'beam.pt.apSigma': '= Ap × σp0',
  'beam.pt.lossParameters': 'Tapsparametere (EC2 5.10.5-6)',
  'beam.pt.frictionMu': 'Friksjon μ',
  'beam.pt.typ019': 'Typisk 0,19–0,25',
  'beam.pt.wobbleK': 'Wobble k (1/m)',
  'beam.pt.typ0005': 'Typisk 0,005–0,01',
  'beam.pt.anchorageSlip': 'Forankringsglidning (mm)',
  'beam.pt.typ6mm': 'Typisk 6 mm',
  'beam.pt.bondType': 'Hefttype',
  'beam.pt.unbonded': 'Uten heft',
  'beam.pt.grouted': 'Injisert (med heft)',
  'beam.pt.groutedLabel': ' [Injisert]',
  'beam.pt.prestressEffect': 'Spennkrafteffekt (EC2 2.4.2.2)',
  'beam.pt.favorableOption': 'Gunstig (γP = 1.0) – spennkraft reduserer virkninger',
  'beam.pt.unfavorableOption': 'Ugunstig (γP = 1.2) – spennkraft øker virkninger',
  'beam.pt.effectHint': 'Velg ut fra om spennkraften hjelper eller motvirker dimensjoneringskontrollen',
  'beam.pt.favorableLabel': 'Gunstig:',
  'beam.pt.favorableText': 'Spennkraft motvirker tyngde (typisk for feltmoment).',
  'beam.pt.unfavorableLabel': 'Ugunstig:',
  'beam.pt.unfavorableText': 'Spennkraft øker virkningene (f.eks. støttemoment over opplagre).',
  'beam.pt.cableProfile': 'Kabelprofil',
  'beam.pt.endSupportEcc': 'Eksentrisitet endeopplager (m)',
  'beam.pt.typically0': 'Vanligvis 0',
  'beam.pt.interiorSupportEcc': 'Eksentrisitet midtopplager (m)',
  'beam.pt.aboveNA': 'Over NA (maks: {max}m)',
  'beam.pt.midSpanEcc': 'Eksentrisitet i felt (m)',
  'beam.pt.belowNA': 'Under NA (maks: {max}m)',
  'beam.pt.calculating': 'Beregner …',
  'beam.pt.calculatingLosses': 'Beregner tap …',
  'beam.pt.failedToCalculate': 'Kunne ikke beregne tap',
  'beam.pt.lossPreview': 'Forhåndsvisning av spenntap (EC2)',
  'beam.pt.immediateLosses': 'Umiddelbare tap',
  'beam.pt.friction': 'Friksjon (5.10.5.2):',
  'beam.pt.anchorageSlipLoss': 'Forankringsglidning (5.10.5.3):',
  'beam.pt.elasticShortening': 'Elastisk forkorting (5.10.5.1):',
  'beam.pt.subtotal': 'Delsum:',
  'beam.pt.timeDependent': 'Tidsavhengig (50 år)',
  'beam.pt.relaxation': 'Relaksasjon (3.3.2):',
  'beam.pt.creep': 'Kryp (5.10.6):',
  'beam.pt.shrinkage': 'Svinn (5.10.6):',
  'beam.pt.initialForceShort': 'Initiell kraft',
  'beam.pt.totalLoss': 'Totalt tap',
  'beam.pt.effectiveForce': 'Effektiv kraft',
  'beam.pt.addCableAria': 'Legg til spennkabel på bjelken',
  'beam.pt.singleSpanNote': 'For ettfelts bjelker er kabelprofilen parabolsk fra ende til ende.',

  // ===== Beam designer — results tab =====
  'beam.results.catVariable': 'Variabel (Q)',
  'beam.results.catSnow': 'Snø',
  'beam.results.catWind': 'Vind',
  'beam.results.catPermanent': 'Permanent (G)',
  'beam.results.catEnvelope': 'Omhylling',
  'beam.results.noVariableLeading': 'Ingen ledende variabel',
  'beam.results.leading': 'Ledende: {category}',
  'beam.results.multiLimitState': 'Analyse for flere grensetilstander',
  'beam.results.beamTheory': 'Bjelketeori',
  'beam.results.analyzing': 'Analyserer …',
  'beam.results.timoshenkoTitle': 'Inkluderer skjærdeformasjon – anbefalt for høye bjelker (L/h < 10)',
  'beam.results.eulerDesc': 'Standardteori for slanke bjelker (L/h > 20)',
  'beam.results.timoshenkoDesc': 'Inkluderer skjærdeformasjon – for høye bjelker (L/h < 10)',
  'beam.results.timberAlwaysTimoshenko': 'Tre kjøres alltid med Timoshenko: skjærdeformasjon er vesentlig for tre (NS-EN 1995-1-1 §2.2.3(2)), så begge knappene bruker analysen med skjærdeformasjon.',
  'beam.results.yourBeam': 'Din bjelke: L/h = {ratio}',
  'beam.results.slenderNote': ' (slank — Euler-Bernoulli passer)',
  'beam.results.intermediateNote': ' (mellomliggende — vurder Timoshenko)',
  'beam.results.deepNote': ' (høy bjelke — Timoshenko anbefales)',
  'beam.results.analysisCompleted': '{theory}-analyse fullført – velg grensetilstand under',
  'beam.results.selectTheoryHint': 'Velg bjelketeori og klikk for å analysere',
  'beam.results.limitState': 'Grensetilstand',
  'beam.results.ulsOption': 'Brudd (ULS)',
  'beam.results.slsCharacteristic': 'Bruk – karakteristisk',
  'beam.results.slsFrequent': 'Bruk – ofte forekommende',
  'beam.results.slsQuasi': 'Bruk – tilnærmet permanent',
  'beam.results.runFirstLimitStates': 'Kjør analyse først for å velge grensetilstander',
  'beam.results.loadCombinations': 'Lastkombinasjoner',
  'beam.results.loadCaseFactors': 'Lasttilfellefaktorer',
  'beam.results.thCategory': 'Kategori',
  'beam.results.thLeading': 'Ledende',
  'beam.results.thApplied': 'Anvendt',
  'beam.results.yes': 'Ja',
  'beam.results.no': 'Nei',
  'beam.results.envelopeNotice': 'Omhylling vist – verdiene representerer maksimal respons over alle lastkombinasjoner.',
  'beam.results.diagramType': 'Diagramtype',
  'beam.results.displayOptions': 'Visningsalternativer',
  'beam.results.showValues': 'Vis verdier',
  'beam.results.highlightMaxMin': 'Marker maks/min',
  'beam.results.valuePrecision': 'Verdipresisjon',
  'beam.results.dp2': '2 des.',
  'beam.results.dp4': '4 des.',
  'beam.results.fontSize': 'Skriftstørrelse',
  'beam.results.diagramScale': 'Diagramskala',
  'beam.results.valueDensity': 'Verditetthet',
  'beam.results.everyNPts': 'Hver {n} pkt',
  'beam.results.valueDensityHint': 'Styrer hvor mange tallverdier som vises på viktige steder',
  'beam.results.runFirstDiagrams': 'Kjør analyse først for å se resultatdiagrammer.',
  'beam.results.analysisComplete': 'Analyse fullført! Se diagrammer i visningspanelet.',
  'beam.results.analysisFailedMsg': 'Analysen mislyktes. Kontroller bjelkekonfigurasjonen.',
  'beam.results.cardMomentTitle': 'Moment',
  'beam.results.cardMomentDesc': 'Momentdiagram',
  'beam.results.cardShearTitle': 'Skjær',
  'beam.results.cardShearDesc': 'Skjærkraftdiagram',
  'beam.results.cardDeflectionTitle': 'Nedbøyning',
  'beam.results.cardDeflectionDesc': 'Forskyvningskurve',
  'beam.results.cardAxialTitle': 'Aksial',
  'beam.results.cardAxialDesc': 'Aksialkraftdiagram',
  'beam.results.cardReactionsTitle': 'Reaksjoner',
  'beam.results.cardReactionsDesc': 'Opplagerreaksjoner',
  'beam.results.cardAxialDispTitle': 'Aksialforskyvn.',
  'beam.results.cardAxialDispDesc': 'Aksialforskyvning (mm)',
  'beam.results.labelMoment': 'Momentdiagram',
  'beam.results.labelShear': 'Skjærdiagram',
  'beam.results.labelDeflection': 'Nedbøyningskurve',
  'beam.results.labelAxial': 'Aksialkraftdiagram',
  'beam.results.labelAxialDisp': 'Aksialforskyvning',
  'beam.results.labelReactions': 'Opplagerreaksjoner',
  'beam.results.badgeUls': 'ULS-kombinasjon',
  'beam.results.badgeSlsChar': 'SLS – karakteristisk',
  'beam.results.badgeSlsFreq': 'SLS – ofte forekommende',
  'beam.results.badgeSlsQuasi': 'SLS – tilnærmet permanent',
  'beam.results.dataAvailable': 'Data tilgjengelig',

  // ===== Beam designer — response tab =====
  'beam.response.calcRunning': 'Beregner respons …',
  'beam.response.calc': 'Beregn respons',
  'beam.response.calcHint': 'Klikk for å beregne tøyninger, spenninger og utnyttelser fra analyseresultatene',
  'beam.response.dataLoaded': 'Responsdata lastet',
  'beam.response.urUls': 'Utnyttelsesgrader (UR) – ULS',
  'beam.response.urSls': 'Utnyttelsesgrader (UR) – SLS',
  'beam.response.showDetailsCombo': 'Vis detaljer for valgt lastkombinasjon',
  'beam.response.noUlsCombos': 'Ingen ULS-kombinasjoner',
  'beam.response.noSlsCombos': 'Ingen SLS-kombinasjoner',
  'beam.response.strainsStresses': 'Tøyninger og spenninger',
  'beam.response.strainStressInfo': 'Basert på lineær elastisk stivhet (E·I) – kun til informasjon. Rimelig nøyaktig for stål og tre, men gjenspeiler ikke opprisset eller plastisk oppførsel i betongtverrsnitt.',
  'beam.response.stresses': 'Spenninger',
  'beam.response.strains': 'Tøyninger',
  'beam.response.urMaxOverallTitle': 'Maks samlet UR',
  'beam.response.urMaxOverallDesc': 'Samlet maksimum',
  'beam.response.urBendingTitle': 'Bøyning UR',
  'beam.response.urBendingDesc': 'Bøyekapasitet',
  'beam.response.urShearTitle': 'Skjær UR',
  'beam.response.urShearDesc': 'Skjærkapasitet',
  'beam.response.urCompressionTitle': 'Trykk UR',
  'beam.response.urCompressionDesc': 'Aksialtrykk',
  'beam.response.urTensionTitle': 'Strekk UR',
  'beam.response.urTensionDesc': 'Aksialstrekk',
  'beam.response.slsDeflectionTitle': 'UR nedbøyning',
  'beam.response.slsDeflectionDesc': 'Nedbøyningsgrenser',
  'beam.response.slsDeflectionInstTitle': 'Nedbøyning w_inst',
  'beam.response.slsDeflectionInstDesc': 'Momentan (karakteristisk)',
  'beam.response.slsDeflectionFinalTitle': 'Nedbøyning w_fin',
  'beam.response.slsDeflectionFinalDesc': 'Langtids inkl. kryp',
  'beam.response.slsDeflectionFinalDescSteel': 'Langtids – stål kryper ikke, w_fin = w_inst',
  'beam.response.slsCrackWidthTitle': 'SLS rissvidde',
  'beam.response.slsCrackWidthDesc': 'Rissvidde betong',
  'beam.response.slsConcreteStressTitle': 'SLS betongspenning',
  'beam.response.slsConcreteStressDesc': 'Spenningsgrense betong',
  'beam.response.slsSteelStressTitle': 'SLS stålspenning',
  'beam.response.slsSteelStressDesc': 'Stål-/armeringsspenning',
  'beam.response.slsTimberStressTitle': 'UR trespenning',
  'beam.response.slsTimberStressDesc': 'Spenningsgrense tre',
  'beam.response.nameEpsilonTop': 'Tøyning i topp (ε Top)',
  'beam.response.nameEpsilonMid': 'Tøyning i midte (ε Mid)',
  'beam.response.nameEpsilonBot': 'Tøyning i bunn (ε Bot)',
  'beam.response.nameSigmaTop': 'Normalspenning topp (σ Top)',
  'beam.response.nameSigmaMid': 'Normalspenning midte (σ Mid)',
  'beam.response.nameSigmaBot': 'Normalspenning bunn (σ Bot)',
  'beam.response.nameGammaLower': 'Skjærtøyning nedre (γ Lower)',
  'beam.response.nameGammaMid': 'Skjærtøyning midte (γ Mid)',
  'beam.response.nameGammaUpper': 'Skjærtøyning øvre (γ Upper)',
  'beam.response.nameTauLower': 'Skjærspenning nedre (τ Lower)',
  'beam.response.nameTauMid': 'Skjærspenning midte (τ Mid)',
  'beam.response.nameTauUpper': 'Skjærspenning øvre (τ Upper)',
  'beam.response.nameUrMaxOverall': 'Maksimal samlet utnyttelsesgrad',
  'beam.response.nameUrBending': 'Utnyttelsesgrad bøyning',
  'beam.response.nameUrCompression': 'Utnyttelsesgrad trykk',
  'beam.response.nameUrTension': 'Utnyttelsesgrad strekk',
  'beam.response.nameUrShear': 'Utnyttelsesgrad skjær',
  'beam.response.nameUrSlsDeflection': 'Utnyttelsesgrad SLS nedbøyning',
  'beam.response.nameSlsDeflectionInst': 'SLS momentan nedbøyning w_inst (karakteristisk kombinasjon)',
  'beam.response.nameSlsDeflectionFinal': 'SLS langtidsnedbøyning w_fin inkl. kryp (karakteristisk kombinasjon)',
  'beam.response.nameSlsDeflectionFinalSteel': 'SLS langtidsnedbøyning w_fin = w_inst – stål har ikke kryp (karakteristisk kombinasjon)',
  'beam.response.nameUrSlsCrackWidth': 'Utnyttelsesgrad SLS rissvidde (betong)',
  'beam.response.nameUrSlsConcreteStress': 'Utnyttelsesgrad SLS betongspenning',
  'beam.response.nameUrSlsSteelStress': 'Utnyttelsesgrad SLS stål-/armeringsspenning',
  'beam.response.nameDefault': 'Responsdiagram',
  'beam.response.codeCheck.title': 'Normkontroll – dokumentasjon',
  'beam.response.codeCheck.check': 'Kontroll',
  'beam.response.codeCheck.explanation': 'Forklaring',
  'beam.response.codeCheck.formula': 'Formel og verdier',
  'beam.response.codeCheck.ur': 'UR',
  'beam.response.codeCheck.na': 'I/A',
  'beam.response.noFactorDetails': 'Ingen faktordetaljer tilgjengelig.',
  'beam.response.thLoadCategory': 'Lastkategori',
  'beam.response.badgeLeading': 'Ledende',
  'beam.response.leadingNoColon': 'Ledende {category}',
  'beam.response.uls': 'ULS',
  'beam.response.evaluatedFor': 'Evaluert for: {combination}',
  'beam.response.checkNotEvaluated': 'Denne kontrollen er ikke evaluert for noen lastkombinasjon i denne analysen (grenseverdien er ikke konfigurert eller kontrollen gjelder ikke materialet).',

  // ===== Beam designer — dashboard =====
  'beam.dashboard.greetingMorning': 'God morgen',
  'beam.dashboard.greetingAfternoon': 'God ettermiddag',
  'beam.dashboard.greetingEvening': 'God kveld',
  'beam.dashboard.defaultName': 'Designer',
  'beam.dashboard.welcomeTitle': '{greeting}, {name}',
  'beam.dashboard.readyToDesign': 'Klar til å dimensjonere',
  'beam.dashboard.welcomeSubtitle': 'Start en ny bjelkeanalyse eller fortsett med en mal nedenfor',
  'beam.dashboard.newBlankDesign': 'Ny tom modell',
  'beam.dashboard.newBlankDesc': 'Start fra bunnen av med full kontroll',
  'beam.dashboard.myAccount': 'Min konto',
  'beam.dashboard.myAccountDesc': 'Administrer abonnement og profil',
  'beam.dashboard.beamTemplates': 'Bjelkemaler',
  'beam.dashboard.beamTemplatesDesc': 'Forhåndskonfigurerte bjelkemodeller for vanlige konstruksjonsscenarioer. Velg en mal for å komme raskt i gang.',
  'beam.dashboard.materialConcrete': 'Betong',
  'beam.dashboard.materialSteel': 'Stål',
  'beam.dashboard.materialTimber': 'Trevirke',
  'beam.dashboard.whyChoose': 'Hvorfor velge StructuraMatrix Bjelkedesigner?',
  'beam.dashboard.benefitMultiSpanLabel': 'Flerfeltsanalyse:',
  'beam.dashboard.benefitMultiSpanDesc': 'Kontinuerlige bjelker med ubegrenset antall felt',
  'beam.dashboard.benefitEurocodeLabel': 'Eurokode-samsvar:',
  'beam.dashboard.benefitEurocodeDesc': 'Normkontroll for stål, betong og trevirke',
  'beam.dashboard.benefitVisualizationLabel': 'Interaktiv visualisering:',
  'beam.dashboard.benefitVisualizationDesc': 'Sanntidsresultater med profesjonelle diagrammer',
  'beam.dashboard.benefitResultsLabel': 'Profesjonelle resultater:',
  'beam.dashboard.benefitResultsDesc': 'Detaljerte ingeniørberegninger og rapporter',
  'beam.dashboard.technicalFeatures': 'Tekniske funksjoner',
  'beam.dashboard.featureLoadTypes': 'Flere lasttyper (punkt, fordelt, triangulær)',
  'beam.dashboard.featureDiagrams': 'Moment-, skjær- og nedbøyningsdiagrammer',
  'beam.dashboard.featureReactions': 'Opplagerreaksjoner og utnyttelsesgrader',
  'beam.dashboard.featureLoadCases': 'Håndtering av lasttilfeller og kombinasjoner',
  'beam.dashboard.useTemplate': 'Bruk mal',
  'beam.dashboard.spansSingular': '{count} felt ({lengths}m)',
  'beam.dashboard.spansPlural': '{count} felt ({lengths}m)',
  'beam.dashboard.solidSuffix': ' (Heltre)',
  'beam.dashboard.glulamSuffix': ' (Limtre)',
  // Concrete templates
  'beam.dashboard.tpl.concrete-residential.name': 'Boligdekke',
  'beam.dashboard.tpl.concrete-residential.description': 'Enfeltsbjelke for dekkesystemer i boliger og leiligheter.',
  'beam.dashboard.tpl.concrete-residential.load': '5 kN/m² nyttelast + påstøp',
  'beam.dashboard.tpl.concrete-office.name': 'Kontor kontinuerlig',
  'beam.dashboard.tpl.concrete-office.description': 'Tofelts kontinuerlig bjelke for kontorbygg med moderat last.',
  'beam.dashboard.tpl.concrete-office.load': '3 kN/m² nyttelast + lettvegger',
  'beam.dashboard.tpl.concrete-parking.name': 'Parkeringskonstruksjon',
  'beam.dashboard.tpl.concrete-parking.description': 'Trefelts kontinuerlig bjelke for parkeringsdekker i flere etasjer.',
  'beam.dashboard.tpl.concrete-parking.load': '2,5 kN/m² kjøretøy',
  'beam.dashboard.tpl.concrete-industrial.name': 'Industridekke',
  'beam.dashboard.tpl.concrete-industrial.description': 'Kraftig kontinuerlig bjelke for industrigulv med utstyrslaster.',
  'beam.dashboard.tpl.concrete-industrial.load': '15 kN/m² maskineri',
  'beam.dashboard.tpl.concrete-transfer.name': 'Overføringsbjelke',
  'beam.dashboard.tpl.concrete-transfer.description': 'Høy overføringsbjelke som bærer søyler over. Store punktlaster.',
  'beam.dashboard.tpl.concrete-transfer.load': 'Søylelaster 500+ kN',
  // Steel templates
  'beam.dashboard.tpl.steel-industrial.name': 'Industribjelke',
  'beam.dashboard.tpl.steel-industrial.description': 'Kraftig enfeltsbjelke for lagerhaller og industribygg.',
  'beam.dashboard.tpl.steel-industrial.load': '10 kN/m² lager',
  'beam.dashboard.tpl.steel-bridge.name': 'Gangbru',
  'beam.dashboard.tpl.steel-bridge.description': 'Enfelts dragerbjelke for gangbruer og opphøyde gangveier.',
  'beam.dashboard.tpl.steel-bridge.load': '5 kN/m² gangtrafikk',
  'beam.dashboard.tpl.steel-mezzanine.name': 'Mesaningulv',
  'beam.dashboard.tpl.steel-mezzanine.description': 'Tofelts kontinuerlig bjelke for kontormesanin eller mellometasjer.',
  'beam.dashboard.tpl.steel-mezzanine.load': '5 kN/m² kontor',
  'beam.dashboard.tpl.steel-roof-purlin.name': 'Takås',
  'beam.dashboard.tpl.steel-roof-purlin.description': 'Lett stålås for bæring av takkledning i industribygg.',
  'beam.dashboard.tpl.steel-roof-purlin.load': 'Snø + kledning',
  'beam.dashboard.tpl.steel-platform.name': 'Plattformbjelke',
  'beam.dashboard.tpl.steel-platform.description': 'Bjelke for industriplattform eller gangbane med rekkverk- og ristlaster.',
  'beam.dashboard.tpl.steel-platform.load': '3 kN/m² plattform',
  // Timber templates
  'beam.dashboard.tpl.timber-roof-simple.name': 'Takbjelke enkel',
  'beam.dashboard.tpl.timber-roof-simple.description': '10,0 m sideavstivet limtrebjelke for tak, med takoppbygning, snø og vind.',
  'beam.dashboard.tpl.timber-roof-simple.load': 'Gk 0,6 + sk 2,0 kN/m² · 3,0 m lastbredde',
  'beam.dashboard.tpl.timber-roof-overhang.name': 'Tak med utstikk',
  'beam.dashboard.tpl.timber-roof-overhang.description': '8,0 m sideavstivet limtrebjelke med 1,5 m fritt utkraget takfot og økt snølast på utkragingen.',
  'beam.dashboard.tpl.timber-roof-overhang.load': 'Taklast + snø 4,5/7,0 kN/m + vind',
  'beam.dashboard.tpl.timber-floor-multispan.name': 'Gulv flerfelt',
  'beam.dashboard.tpl.timber-floor-multispan.description': 'Trefelts kontinuerlig C24-gulvbjelke, c/c 600 mm, sideavstivet av gulvet.',
  'beam.dashboard.tpl.timber-floor-multispan.load': 'Gk 0,75 + qk 2,0 kN/m² · c/c 600',
  'beam.dashboard.tpl.timber-floor-joist.name': 'Gulvbjelke',
  'beam.dashboard.tpl.timber-floor-joist.description': '3,6 m C24-gulvbjelke, 48×223 mm c/c 600 mm, med sideavstivning fra gulvet.',
  'beam.dashboard.tpl.timber-floor-joist.load': 'Gk 0,75 + qk 2,0 kN/m² · c/c 600',
  'beam.dashboard.tpl.timber-carport.name': 'Carport / overbygg',
  'beam.dashboard.tpl.timber-carport.description': '6,0 m limtrebjelke, sideavstivet av taket, med 1,0 m fritt utkragede ender på begge sider.',
  'beam.dashboard.tpl.timber-carport.load': 'Lett tak + snø 4,0 kN/m + vind',
  'beam.dashboard.tpl.timber-ridge-beam.name': 'Mønedrager',
  'beam.dashboard.tpl.timber-ridge-beam.description': '7,5 m sideavstivet limtredrager som bærer sperrene ved mønet i et saltak.',
  'beam.dashboard.tpl.timber-ridge-beam.load': 'Gk 0,5 + sk 1,5 kN/m² · 4,0 m lastbredde',
  'beam.dashboard.load.selfWeight': 'G1 – Egenvekt',
  'beam.dashboard.load.roofBuildUp': 'G2 – Takoppbygning',
  'beam.dashboard.load.lightRoofBuildUp': 'G2 – Lett takoppbygning',
  'beam.dashboard.load.floorBuildUp': 'G2 – Gulvoppbygning',
  'beam.dashboard.load.residential': 'Q – Nyttelast bolig, kategori A',
  'beam.dashboard.load.snow': 'S – Snølast',
  'beam.dashboard.load.snowWithDrift': 'S – Snølast med fonning',
  'beam.dashboard.load.windPressure': 'W – Vindtrykk nedover',
  'beam.dashboard.timberTemplateAssumptions': 'Eksemplene bruker illustrative karakteristiske laster og forutsatt lastbredde. Kontroller alltid stedlig snø- og vindlast, faktisk lastbredde, sideavstivning og forbindelser før prosjektering.',

  // ===== Beam designer — report tab =====
  'beam.report.title': 'Beregningsrapport',
  'beam.report.generateNew': 'Generer ny rapport',
  'beam.report.completeAnalysisFirst': 'Fullfør analysen i Respons-fanen før du genererer en rapport.',
  'beam.report.analysisCompleteCanGenerate': 'Analyse fullført. Du kan nå generere en beregningsrapport.',
  'beam.report.previousReports': 'Tidligere rapporter',
  'beam.report.noReports': 'Ingen rapporter generert ennå.',
  'beam.report.thProjectName': 'Prosjektnavn',
  'beam.report.thProjectId': 'Prosjekt-ID',
  'beam.report.thBeamType': 'Bjelketype',
  'beam.report.thGenerated': 'Generert',
  'beam.report.thVerifiedBy': 'Verifisert av',
  'beam.report.thActions': 'Handlinger',
  'beam.report.verifyThis': 'Verifiser denne rapporten',
  'beam.report.verify': 'Verifiser',
  'beam.report.statusVerified': 'VERIFISERT',
  'beam.report.statusNotApproved': 'IKKE GODKJENT',
  'beam.report.downloadPdf': 'Last ned PDF',
  'beam.report.delete': 'Slett',
  'beam.report.confirmDelete': 'Er du sikker på at du vil slette denne rapporten?',
  'beam.report.errLoadList': 'Kunne ikke laste rapportliste',
  'beam.report.errLoading': 'Feil ved lasting av rapporter: {message}',
  'beam.report.errResultRequired': 'Analyseresultat kreves. Kjør analysen først.',
  'beam.report.errNoAnalysisId': 'Analyse-ID ikke funnet. Kjør analysen på nytt.',
  'beam.report.errGenerate': 'Kunne ikke generere rapport',
  'beam.report.errGenerating': 'Feil ved generering av rapport: {message}',
  'beam.report.errDownload': 'Kunne ikke laste ned rapport',
  'beam.report.errDownloading': 'Feil ved nedlasting av rapport: {message}',
  'beam.report.errDelete': 'Kunne ikke slette rapport',
  'beam.report.errDeleting': 'Feil ved sletting av rapport: {message}',
  'beam.report.errVerify': 'Kunne ikke verifisere rapport',
  'beam.report.errVerifying': 'Feil ved verifisering av rapport: {message}',

  // ----- Report settings dialog -----
  'beam.report.settingsTitle': 'Generer beregningsrapport',
  'beam.report.projectName': 'Prosjektnavn',
  'beam.report.projectNamePlaceholder': 'Bjelkedimensjonering',
  'beam.report.projectId': 'Prosjekt-ID',
  'beam.report.autoGenerated': 'Genereres automatisk',
  'beam.report.designerName': 'Prosjekterendes navn',
  'beam.report.designerPlaceholder': 'Skriv inn navn på prosjekterende',
  'beam.report.companyName': 'Firmanavn',
  'beam.report.companyPlaceholder': 'Skriv inn firmanavn',
  'beam.report.projectDescription': 'Prosjektbeskrivelse',
  'beam.report.descriptionPlaceholder': 'Kort beskrivelse av prosjektet og konstruksjonen',
  'beam.report.appearsSection1': 'Vises i kapittel 1 i rapporten',
  'beam.report.purpose': 'Formål',
  'beam.report.purposePlaceholder': 'Formålet med denne beregningen og tiltenkt bruk',
  'beam.report.noteLabel': 'Merk:',
  'beam.report.noteText': 'Rapporten genereres som et PDF-dokument og lastes automatisk ned til enheten din. Filen inneholder fullstendige analyseresultater, dimensjoneringsberegninger og detaljerte diagrammer.',
  'beam.report.generating': 'Genererer …',
  'beam.report.generateReport': 'Generer rapport',

  // ----- Verification dialog -----
  'beam.report.verifyTitle': 'Verifiser beregningsrapport',
  'beam.report.verificationStatus': 'Verifikasjonsstatus',
  'beam.report.approved': 'Godkjent',
  'beam.report.notApproved': 'Ikke godkjent',
  'beam.report.companyNameRequired': 'Firmanavn *',
  'beam.report.companyLogo': 'Firmalogo (valgfritt)',
  'beam.report.logoUploaded': 'Logo lastet opp',
  'beam.report.verifierNameRequired': 'Verifikatørs navn *',
  'beam.report.verifierPlaceholder': 'Skriv inn navn på ansvarlig',
  'beam.report.signature': 'Signatur (valgfritt)',
  'beam.report.signatureUploaded': 'Signatur lastet opp',
  'beam.report.commentsRequired': 'Kommentarer *',
  'beam.report.commentsPlaceholder': 'Skriv inn verifikasjonskommentarer',
  'beam.report.verifying': 'Verifiserer …',
  'beam.report.submitVerification': 'Send verifikasjon',

  // ===== Beam designer — cross-section details table =====
  'beam.section.section': 'Tverrsnitt:',
  'beam.section.material': 'Materiale:',
  'beam.section.width': 'Bredde:',
  'beam.section.height': 'Høyde:',
  'beam.section.area': 'Areal:',
  'beam.section.inertia': 'Treghetsmoment',
  'beam.section.approx': 'Tilnærmet',
  'beam.section.webT': 'Steg t:',
  'beam.section.flangeT': 'Flens t:',
  'beam.section.sectionClass': 'Tverrsnittsklasse:',
  'beam.section.shearFactor': 'κ (skjærfaktor):',
  'beam.section.reinforcement': 'armering',
  'beam.section.effectiveDepth': 'effektiv høyde',
  'beam.section.reinforcementRatio': 'armeringsforhold',
  'beam.section.shearReinforcement': 'skjærarmering',
  'beam.section.plasticModulusUnavailable': 'Plastisk motstandsmoment utilgjengelig',
  'beam.section.classShort1': 'Klasse 1 – Plastisk',
  'beam.section.classShort2': 'Klasse 2 – Kompakt',
  'beam.section.classShort3': 'Klasse 3 – Halvkompakt',
  'beam.section.classShort4': 'Klasse 4 – Slank',
  'beam.section.classShortN': 'Klasse {n}',
  'beam.section.classAutoGeometry': 'Auto (beregnet fra geometri)',
  'beam.section.autoSuffix': ' (auto)',

  // ===== Beam designer — visualization controls & misc =====
  'beam.viz.fitAll': 'Tilpass alt',
  'beam.viz.resetView': 'Tilbakestill visning',
  'beam.viz.dragToResize': 'Dra for å endre størrelse',
  'beam.viz.noCrossSection': 'Ingen tverrsnitt definert',
  'beam.viz.strain': 'Tøyning ε',
  'beam.viz.stress': 'Spenning σ',
  'beam.viz.utilization': 'Utnyttelse',
  'beam.common.unknownTab': 'Ukjent fane',
  'beam.common.close': 'Lukk',

  // ===== Beam designer — buckling details modal =====
  'beam.buckling.title': 'Andreordens effekter – knekkanalyse',
  'beam.buckling.resultScope': 'Resultatomfang:',
  'beam.buckling.globalOverall': 'Global / hele bjelken',
  'beam.buckling.spanOption': 'Felt {n} (L = {length} m)',
  'beam.buckling.globalSummary': 'Oppsummering global knekking',
  'beam.buckling.spanSummary': 'Oppsummering knekking felt {n}',
  'beam.buckling.criticalMode': 'Kritisk modus:',
  'beam.buckling.none': 'Ingen',
  'beam.buckling.maxUtilization': 'Maks utnyttelse:',
  'beam.buckling.status': 'Status:',
  'beam.buckling.pass': '✓ BESTÅTT',
  'beam.buckling.fail': '✗ IKKE BESTÅTT',
  'beam.buckling.mnDiagram': 'M-N-interaksjonsdiagram',
  'beam.buckling.axialForce': 'Aksialkraft',
  'beam.buckling.moment': 'Moment',
  'beam.buckling.axialForceAxis': 'Aksialkraft N [kN]',
  'beam.buckling.momentAxis': 'Moment M [kN⋅m]',
  'beam.buckling.secondOrderResistance': 'Andreordens kapasitet',
  'beam.buckling.designPoint': 'Dimensjonerende punkt',
  'beam.buckling.mnNote': 'Dette er en forenklet lineær interaksjonskurve. Faktiske kapasitetskurver kan være ikke-lineære avhengig av materiale og tverrsnittsegenskaper.',
  'beam.buckling.modesSummary': 'Oppsummering knekkmoduser',
  'beam.buckling.thMode': 'Modus',
  'beam.buckling.thDescription': 'Beskrivelse',
  'beam.buckling.thStatus': 'Status',
  'beam.buckling.noModes': 'Ingen knekkmoduser beregnet for dette valget.',
  'beam.buckling.legendLabel': 'Tegnforklaring:',
  'beam.buckling.legendText': 'L_eff = effektiv lengde, λ = slankhet, χ = reduksjonsfaktor, UR = utnyttelsesgrad',
  'beam.buckling.note': 'Merk:',

  // ===== Beam designer — dynamics details modal =====
  // Kun frekvensSCREENING — modalen skal aldri vise normbasert PASS/FAIL: NS-EN 1995-1-1
  // §7.3.3-verifikasjonen for gulv utføres ikke (se backend DynamicAnalysisResult).
  'beam.dynamics.title': 'Dynamisk oppførsel – vibrasjonsestimat',
  'beam.dynamics.noResults': 'Ingen dynamikkresultater tilgjengelig. Beregn dynamikk først.',
  'beam.dynamics.summary': 'Oppsummering frekvensestimat (globalt system, permanent masse-gravitasjonstilfelle)',
  'beam.dynamics.fundamentalFreq': 'Egenfrekvens (f₁):',
  'beam.dynamics.screeningThreshold': 'Screeningterskel:',
  'beam.dynamics.aboveScreening': 'f₁ er over screeningterskelen. Kun screening — den fulle vibrasjonsverifikasjonen utføres ikke.',
  'beam.dynamics.belowScreening': 'f₁ er på eller under screeningterskelen — særskilt undersøkelse kreves (NS-EN 1995-1-1 §7.3.3(1)).',
  'beam.dynamics.reference': 'Referanse:',
  'beam.dynamics.naturalFrequencies': 'Egenfrekvenser (estimater)',
  'beam.dynamics.modeNumber': 'Modusnummer',
  'beam.dynamics.frequencyHz': 'Frekvens [Hz]',
  'beam.dynamics.tooltipFrequency': 'Frekvens: {value} Hz',
  'beam.dynamics.tooltipPeriod': 'Periode: {value} s',
  'beam.dynamics.continuousNote': 'Merk: For kontinuerlige bjelker representerer disse frekvensene det globale systemets oppførsel. Modus 1 bruker gravitasjonsdeformasjonen av permanent masse (Rayleigh); høyere moduser er fritt opplagt-tilnærminger.',
  'beam.dynamics.timberFloorEstimates': 'Vibrasjonsestimater for tregulv (informativt)',
  'beam.dynamics.fundamentalFreqRow': 'Egenfrekvens:',
  'beam.dynamics.unitImpulseVelocity': 'Estimat impulshastighet:',
  'beam.dynamics.modalMass': 'Permanent (svingende) masse:',
  'beam.dynamics.dampingRatio': 'Antatt dempningsforhold:',
  'beam.dynamics.timberEstimateNote': 'Disse tallene er kun grove estimater. Kriteriene i NS-EN 1995-1-1 §7.3.3 (uttrykk (7.3)-(7.7) med NA.7.3.3-parametrene) beregnes ikke.',

  // ===== Pages — shared =====
  'pages.logoAlt': 'StructuraMatrix-logo',

  // ----- Home page -----
  'pages.home.heroTitle': 'Profesjonelle tjenester for konstruksjonsanalyse',
  'pages.home.heroSubtitle': 'Avansert analyse av kontinuerlige bjelker med interaktiv visualisering i nettleseren.',
  'pages.home.register': 'Registrer deg',
  'pages.home.signIn': 'Logg inn',
  'pages.home.whyChoose': 'Hvorfor velge StructuraMatrix Bjelkedesigner?',
  'pages.home.multiSpanLabel': 'Flerfeltsanalyse:',
  'pages.home.multiSpanText': 'Kontinuerlige bjelker med ubegrenset antall felt',
  'pages.home.eurocodeLabel': 'Eurokode-samsvar:',
  'pages.home.eurocodeText': 'Kontroll for stål, betong og tre',
  'pages.home.interactiveLabel': 'Interaktiv visualisering:',
  'pages.home.interactiveText': 'Sanntidsresultater med profesjonelle diagrammer',
  'pages.home.professionalLabel': 'Profesjonelle resultater:',
  'pages.home.professionalText': 'Detaljerte beregninger og rapporter',
  'pages.home.technicalFeatures': 'Tekniske funksjoner',
  'pages.home.feat1': 'Flere lasttyper (punkt, fordelt, trekant)',
  'pages.home.feat2': 'Moment-, skjær- og nedbøyningsdiagrammer',
  'pages.home.feat3': 'Opplagerreaksjoner og utnyttelsesgrader',
  'pages.home.feat4': 'Håndtering av lasttilfeller og kombinasjoner',

  // ----- About page -----
  'pages.about.subtitle': 'Profesjonell plattform for konstruksjonsanalyse',
  'pages.about.ourMission': 'Vårt oppdrag',
  'pages.about.missionText': 'Vi gir ingeniører verktøy til å jobbe smartere, ikke hardere.',
  'pages.about.whatWeOffer': 'Hva vi tilbyr',
  'pages.about.beamDesigner': 'Bjelkedesigner',
  'pages.about.beamDesignerText': 'Avansert analyse av kontinuerlige bjelker med støtte for flere felt og omfattende resultater.',
  'pages.about.structuraBitsText': 'Pedagogiske artikler om konstruksjonsteknisk teori, vakkert presentert.',
  'pages.about.eurocodeCompliance': 'Eurokode-samsvar',
  'pages.about.eurocodeText': 'Full kontroll for stål-, betong- og trekonstruksjoner etter europeiske standarder.',
  'pages.about.visualResults': 'Visuelle resultater',
  'pages.about.visualResultsText': 'Interaktive diagrammer for momenter, skjærkrefter og nedbøyninger med profesjonell utskrift.',
  'pages.about.theTeam': 'Teamet',
  'pages.about.teamIntro': 'StructuraMatrix er utviklet av et tverrfaglig team av konstruksjonsingeniører og programvarearkitekter som deler en lidenskap for å levere pålitelige analyseverktøy til praktiserende ingeniører.',
  'pages.about.teamDetail1': 'Ingeniørgruppen vår validerer hver utgivelse mot Eurokode-referanser og virkelige case-studier, og sikrer at den numeriske kjernen møter forventningene i profesjonell praksis.',
  'pages.about.teamDetail2': 'Produkt- og opplevelsesteamet fokuserer på klarhet og brukervennlighet, og gjør komplekse ingeniørarbeidsflyter om til intuitive grensesnitt som hjelper både erfarne fagfolk og nye talenter med å jobbe trygt.',
  'pages.about.logoStory': 'Historien bak StructuraMatrix-logoen',
  'pages.about.logoDesc1': 'Skjønnheten i matematikken som modellerer fysisk oppførsel er hjerteslaget til StructuraMatrix. Vår skjellinspirerte form gjenspeiler de elegante kurvene til de analytiske løsningene ingeniører tegner når de forutsier nedbøyning, vibrasjon og likevekt. Hver kontur er en påminnelse om at ligninger ikke er abstrakte symboler, men levende veivisere som avslører hvordan virkelige konstruksjoner puster under last.',
  'pages.about.logoDesc2': 'Rutenettet som ligger over formen, nikker til det samarbeidende håndverket i teamet vårt – konstruksjonsingeniører og programvarearkitekter som oversetter streng teori til pålitelige digitale verktøy. Hver kryssende linje speiler samspillet mellom numerisk presisjon og menneskelig innsikt, og fanger historien om hvordan vi gjør kompleks oppførsel om til klarhet for praktiserende fagfolk.',
  'pages.about.versionInfo': 'Versjonsinformasjon',
  'pages.about.currentVersion': 'Gjeldende versjon:',
  'pages.about.releaseDate': 'Utgivelsesdato:',
  'pages.about.releaseDateValue': 'Oktober 2025',
  'pages.about.platform': 'Plattform:',
  'pages.about.platformValue': 'Nettapplikasjon',
  'pages.about.status': 'Status:',
  'pages.about.statusValue': 'Aktiv utvikling',
  'pages.about.startToday': 'Ta i bruk StructuraMatrix i dag',
  'pages.about.ctaText': 'Bli med ingeniører over hele verden som stoler på StructuraMatrix for sine analysebehov.',
  'pages.about.tryBeamDesigner': 'Prøv Bjelkedesigner',
  'pages.about.exploreStructuraBits': 'Utforsk Structura-Bits',

  // ===== Admin — shell =====
  'admin.panelTitle': 'Administratorpanel',
  'admin.menu.samples': 'Eksempelrapporter',
  'admin.menu.geometry': 'Geometribibliotek',
  'admin.menu.materials': 'Materialbibliotek',
  'admin.menu.loads': 'Lastbibliotek',
  'admin.menu.library': 'Komplette bjelker',
  'admin.menu.structurabits': 'Structura-Bits-rekkefølge',
  'admin.menu.users': 'Brukeradministrasjon',
  'admin.menu.regression': 'Regresjonstester',

  // ===== Admin — users section =====
  'admin.users.newUser': 'Ny bruker',
  'admin.users.introBefore': 'Administrer StructuraMatrix-brukerkontoer lagret i',
  'admin.users.introAfter': '. Oppretting eller redigering av en bruker her oppdaterer abonnementsnivået og, hvis et passord oppgis, de lokale påloggingsdetaljene.',
  'admin.users.loading': 'Laster brukere …',
  'admin.users.thEmail': 'E-post',
  'admin.users.thName': 'Navn',
  'admin.users.thTier': 'Nivå',
  'admin.users.thCreated': 'Opprettet',
  'admin.users.thLastLogin': 'Siste pålogging',
  'admin.users.thPassword': 'Passord',
  'admin.users.thAdmin': 'Admin',
  'admin.users.thActive': 'Aktiv',
  'admin.users.thActions': 'Handlinger',
  'admin.users.noUsers': 'Ingen brukere funnet.',
  'admin.users.never': 'Aldri',
  'admin.users.passwordSet': 'Satt',
  'admin.users.passwordNone': 'Ingen',
  'admin.users.roleBadgeAdmin': 'Admin',
  'admin.users.roleBadgeUser': 'Bruker',
  'admin.users.statusActive': 'Aktiv',
  'admin.users.statusPending': 'Venter',
  'admin.users.createUser': 'Opprett bruker',
  'admin.users.editUser': 'Rediger bruker',
  'admin.users.email': 'E-post',
  'admin.users.nameOptional': 'Navn (valgfritt)',
  'admin.users.portalId': 'Portal-ID',
  'admin.users.companyName': 'Firmanavn',
  'admin.users.contactEmail': 'Kontakt-e-post',
  'admin.users.companyPitch': 'Firmapresentasjon',
  'admin.users.companyPitchPlaceholder': 'f.eks. Vi prosjekterer sikre og bærekraftige konstruksjoner',
  'admin.users.hqLocation': 'Hovedkontor',
  'admin.users.sectorFocus': 'Bransjefokus',
  'admin.users.serviceKeywords': 'Tjeneste-nøkkelord',
  'admin.users.certifications': 'Sertifiseringer',
  'admin.users.role': 'Rolle',
  'admin.users.roleDesigner': 'Prosjekterende',
  'admin.users.roleApproval': 'Godkjenning',
  'admin.users.roleInfo': 'Info',
  'admin.users.roleAll': 'Alle',
  'admin.users.subscriptionTier': 'Abonnementsnivå',
  'admin.users.tierFree': 'Gratis',
  'admin.users.tierProfessional': 'Profesjonell',
  'admin.users.tierEnterprise': 'Bedrift',
  'admin.users.grantAdmin': 'Gi denne brukeren administratortilgang',
  'admin.users.activateStrong': 'Aktiver bruker',
  'admin.users.activateRest': ' (kreves for å logge inn)',
  'admin.users.password': 'Passord',
  'admin.users.passwordKeepCurrent': '(la stå tom for å beholde nåværende)',
  'admin.users.passwordHelp': 'Setter eller tilbakestiller det lokale påloggingspassordet for denne brukeren.',
  'admin.users.clear': 'Tøm',
  'admin.users.save': 'Lagre',
  'admin.users.pendingResets': 'Ventende passordtilbakestillinger ({count})',
  'admin.users.thRequested': 'Forespurt',
  'admin.users.thExpires': 'Utløper',
  'admin.users.copyLink': 'Kopier lenke',
  'admin.users.copyLinkTitle': 'Kopier tilbakestillingslenke',
  'admin.users.invalidateTitle': 'Ugyldiggjør token',
  'admin.users.resetLinkCopied': 'Tilbakestillingslenke kopiert til utklippstavlen!',
  'admin.users.confirmDelete': 'Slett bruker {email}? Dette kan ikke angres.',
  'admin.users.errLoad': 'Kunne ikke laste brukere',
  'admin.users.errLoadHttp': 'Kunne ikke laste brukere (HTTP {status})',
  'admin.users.errSave': 'Kunne ikke lagre bruker',
  'admin.users.errSaveHttp': 'Kunne ikke lagre bruker (HTTP {status})',
  'admin.users.errDelete': 'Kunne ikke slette bruker',
  'admin.users.errDeleteHttp': 'Kunne ikke slette bruker (HTTP {status}): {text}',

  // ----- Admin common -----
  'admin.common.editComingSoon': 'Rediger (kommer snart)',

  // ----- Admin geometry section -----
  'admin.geometry.title': 'Administrasjon av geometribibliotek',
  'admin.geometry.introBefore': 'Bla gjennom tverrsnittsmaler lastet fra',
  'admin.geometry.introAfter': ', gruppert etter materiale. Verktøy for redigering av momentkapasitet og tverrsnittsegenskaper kommer her.',
  'admin.geometry.loading': 'Laster geometrimaler …',
  'admin.geometry.errLoad': 'Kunne ikke laste geometrimaler',
  'admin.geometry.errLoadHttp': 'Kunne ikke laste geometrimaler (HTTP {status})',
  'admin.geometry.steelSections': 'Ståltverrsnitt',
  'admin.geometry.concreteSections': 'Betongtverrsnitt',
  'admin.geometry.timberSections': 'Tretverrsnitt',
  'admin.geometry.thName': 'Navn',
  'admin.geometry.thType': 'Type',
  'admin.geometry.noTemplatesBefore': 'Ingen geometrimaler funnet i',
  'admin.geometry.noTemplatesAfter': '.',
  'admin.geometry.badgeTemplate': 'Mal',
  'admin.geometry.geometricProperties': 'Geometriske egenskaper',
  'admin.geometry.heightH': 'Høyde (h)',
  'admin.geometry.widthB': 'Bredde (b)',
  'admin.geometry.webThicknessTw': 'Stegtykkelse (tw)',
  'admin.geometry.flangeThicknessTf': 'Flenstykkelse (tf)',
  'admin.geometry.sectionProperties': 'Tverrsnittsegenskaper',
  'admin.geometry.areaA': 'Areal (A)',
  'admin.geometry.momentInertiaIy': 'Treghetsmoment (Iy)',
  'admin.geometry.momentInertiaIz': 'Treghetsmoment (Iz)',
  'admin.geometry.elasticModulusWely': 'Elastisk motstandsmoment (Wel,y)',
  'admin.geometry.plasticModulusWply': 'Plastisk motstandsmoment (Wpl,y)',
  'admin.geometry.sectionClass': 'Tverrsnittsklasse',
  'admin.geometry.momentCapacity': 'Momentkapasitet',
  'admin.geometry.elasticCapacityMel': 'Elastisk kapasitet (Mel)',
  'admin.geometry.plasticCapacityMpl': 'Plastisk kapasitet (Mpl)',
  'admin.geometry.reinforcedCapacityMRd': 'Armert kapasitet (MRd)',
  'admin.geometry.reinforcementProperties': 'Armeringsegenskaper',
  'admin.geometry.bottomReinfArea': 'Armeringsareal i underkant',
  'admin.geometry.effectiveCover': 'Effektiv overdekning',
  'admin.geometry.effectiveDepthD': 'Effektiv høyde (d)',
  'admin.geometry.reinforcementRatioRho': 'Armeringsforhold (ρ)',

  // ----- Admin library section -----
  'admin.library.title': 'Komplett bjelkebibliotek',
  'admin.library.introBefore': 'Forhåndskonfigurerte bjelkemaler lagret i',
  'admin.library.introAfter': ', gruppert etter materialtype. Disse malene inneholder fullstendig geometri, materialer, laster og kodekrav.',
  'admin.library.loading': 'Laster bjelkemaler …',
  'admin.library.errLoad': 'Kunne ikke laste bjelkemaler',
  'admin.library.errLoadHttp': 'Kunne ikke laste bjelkemaler (HTTP {status})',
  'admin.library.errLoadDetailsHttp': 'Kunne ikke laste maldetaljer (HTTP {status})',
  'admin.library.steelBeams': 'Stålbjelker',
  'admin.library.concreteBeams': 'Betongbjelker',
  'admin.library.timberBeams': 'Trebjelker',
  'admin.library.thName': 'Navn',
  'admin.library.thDescription': 'Beskrivelse',
  'admin.library.thCategory': 'Kategori',
  'admin.library.thSpans': 'Felt',
  'admin.library.thOrderMaterial': 'Rekkefølge (materiale)',
  'admin.library.spanUnit': 'felt',
  'admin.library.noTemplatesBefore': 'Ingen bjelkemaler funnet i',
  'admin.library.noTemplatesAfter': '. Databasen seedes ved neste oppstart av backend.',
  'admin.library.loadingDetails': 'Laster detaljer …',
  'admin.library.tabGeometry': 'Geometri',
  'admin.library.tabMaterial': 'Materiale',
  'admin.library.tabLoads': 'Laster',
  'admin.library.tabFullConfig': 'Full konfigurasjon',
  'admin.library.spansAndNodes': 'Felt og knutepunkter',
  'admin.library.thSpan': 'Felt',
  'admin.library.thLengthM': 'Lengde (m)',
  'admin.library.spanRow': 'Felt {n}',
  'admin.library.thNode': 'Node',
  'admin.library.thSupportType': 'Opplagertype',
  'admin.library.thPositionM': 'Posisjon (m)',
  'admin.library.nodeRow': 'Node {n}',
  'admin.library.typeLabel': 'Type:',
  'admin.library.heightLabel': 'Høyde:',
  'admin.library.widthLabel': 'Bredde:',
  'admin.library.materialType': 'Materialtype',
  'admin.library.grade': 'Kvalitet',
  'admin.library.concreteClass': 'Betongklasse',
  'admin.library.timberClass': 'Trekvalitet',
  'admin.library.elasticModulus': 'E-modul',
  'admin.library.density': 'Densitet',
  'admin.library.loadCases': 'Lasttilfeller',
  'admin.library.loadCombinations': 'Lastkombinasjoner',

  // ----- Admin materials section -----
  'admin.materials.title': 'Administrasjon av materialbibliotek',
  'admin.materials.introBefore': 'Bla gjennom materialegenskaper lastet fra',
  'admin.materials.introAfter': ' – Eurokode-kompatible materialdata for konstruksjonsdimensjonering.',
  'admin.materials.loading': 'Laster materialer …',
  'admin.materials.errLoadSummary': 'Kunne ikke laste materialoppsummering',
  'admin.materials.errLoadSummaryHttp': 'Kunne ikke laste materialoppsummering (HTTP {status})',
  'admin.materials.errLoadCategory': 'Kunne ikke laste {category}-materialer',
  'admin.materials.errLoadCategoryHttp': 'Kunne ikke laste {category}-materialer (HTTP {status})',
  'admin.materials.librarySummary': 'Bibliotekoppsummering',
  'admin.materials.steelGrades': 'Stålkvaliteter',
  'admin.materials.concreteClasses': 'Betongklasser',
  'admin.materials.timberClasses': 'Treklasser',
  'admin.materials.reinforcement': 'Armering',
  'admin.materials.prestressing': 'Spennarmering',
  'admin.materials.total': 'Totalt',
  'admin.materials.btnSteel': 'Stål',
  'admin.materials.btnConcrete': 'Betong',
  'admin.materials.btnTimber': 'Tre',
  'admin.materials.btnReinforcement': 'Armering',
  'admin.materials.btnPrestressing': 'Spennarmering',
  'admin.materials.steelTitle': 'Stålmaterialer (EN 1993-1-1)',
  'admin.materials.concreteTitle': 'Betongmaterialer (EN 1992-1-1)',
  'admin.materials.timberTitle': 'Trematerialer (EN 338)',
  'admin.materials.reinforcementTitle': 'Armeringsstål (EN 1992-1-1)',
  'admin.materials.prestressingTitle': 'Spennstål (EN 1992-1-1)',
  'admin.materials.thGrade': 'Kvalitet',
  'admin.materials.thSubgrade': 'Underkvalitet',
  'admin.materials.thProductForm': 'Produktform',
  'admin.materials.thClass': 'Klasse',
  'admin.materials.thKind': 'Type',
  'admin.materials.thDuctilityClass': 'Duktilitetsklasse',
  'admin.materials.thRelaxationClass': 'Relaksasjonsklasse',
  'admin.materials.footerSteel': '{count} stålmaterialer tilgjengelig',
  'admin.materials.footerConcrete': '{count} betongklasser tilgjengelig',
  'admin.materials.footerTimber': '{count} treklasser tilgjengelig',
  'admin.materials.footerReinf': '{count} armeringskvaliteter tilgjengelig',
  'admin.materials.footerPrestress': '{count} spennstålkvaliteter tilgjengelig',

  // ----- Admin cooperative users -----
  'admin.coop.title': 'Samarbeidsbrukere',
  'admin.coop.saveFirst': 'Lagre brukeren først, så kan du legge til samarbeidsbrukere',
  'admin.coop.placeholderUserId': 'Bruker-ID (GUID)',
  'admin.coop.placeholderEmail': 'E-post',
  'admin.coop.placeholderAuth0': 'Auth0-ID (valgfritt)',
  'admin.coop.placeholderName': 'Navn (valgfritt)',
  'admin.coop.add': 'Legg til',
  'admin.coop.noCoopUsers': 'Ingen samarbeidsbrukere',
  'admin.coop.thAction': 'Handling',
  'admin.coop.errUserIdEmailRequired': 'Bruker-ID og e-post er påkrevd',
  'admin.coop.errLoad': 'Kunne ikke laste samarbeidsbrukere',
  'admin.coop.errAdd': 'Kunne ikke legge til samarbeidsbruker',
  'admin.coop.errDelete': 'Kunne ikke slette samarbeidsbruker',
  'admin.coop.confirmRemove': 'Fjern denne samarbeidsbrukeren?',

  // ----- Admin Structura-Bits ordering -----
  'admin.bits.intro': 'Inspiser og kontroller rekkefølgen på Structura-Bits slik de vises på den offentlige siden. Bruk sorteringsvelgeren for å verifisere sekvensen etter dato, tittel eller kategori.',
  'admin.bits.loading': 'Laster Structura-Bits …',
  'admin.bits.errLoad': 'Kunne ikke laste Structura-Bits',
  'admin.bits.errSave': 'Kunne ikke lagre Structura-Bits-rekkefølge',
  'admin.bits.noBits': 'Ingen Structura-Bits funnet.',
  'admin.bits.saved': 'Lagret rekkefølge for {count} Structura-Bits.',
  'admin.bits.orderBy': 'Sorter etter:',
  'admin.bits.sortExplicit': 'Eksplisitt rekkefølge (lagret)',
  'admin.bits.sortDate': 'Dato (nyeste først)',
  'admin.bits.sortTitle': 'Tittel (A → Å)',
  'admin.bits.sortCategory': 'Kategori, deretter tittel',
  'admin.bits.saveOrdering': 'Lagre rekkefølge',
  'admin.bits.thOrder': 'Rekkefølge',
  'admin.bits.thTitle': 'Tittel',
  'admin.bits.thDate': 'Dato',
  'admin.bits.thCategory': 'Kategori',
  'admin.bits.thReadingTime': 'Lesetid',
  'admin.bits.thSlug': 'Slug',

  // ----- Admin loads section -----
  'admin.loads.title': 'Administrasjon av lastbibliotek',
  'admin.loads.introBefore': 'Bla gjennom lasttilfeller lagret i',
  'admin.loads.introAfter': ', gruppert etter kategori. Redigeringsverktøy vil bli utvidet til å støtte detaljerte justeringer av lastmønstre.',
  'admin.loads.loading': 'Laster lasttilfeller …',
  'admin.loads.errLoad': 'Kunne ikke laste lasttilfeller',
  'admin.loads.errLoadHttp': 'Kunne ikke laste lasttilfeller (HTTP {status})',
  'admin.loads.loadCasesSuffix': 'lasttilfeller',
  'admin.loads.thName': 'Navn',
  'admin.loads.thActive': 'Aktiv',
  'admin.loads.thOrder': 'Rekkefølge',
  'admin.loads.thLoads': 'Laster',
  'admin.loads.statusInactive': 'Inaktiv',
  'admin.loads.noLoadCasesBefore': 'Ingen lasttilfeller funnet i',
  'admin.loads.noLoadCasesAfter': '.',

  // ----- Admin samples section -----
  'admin.samples.title': 'Generering av eksempelrapporter',
  'admin.samples.intro': 'Generer eksempler på beregningsrapporter for testing og verifisering. Dette oppretter PDF-rapporter for stål-, betong- og tremateriale.',
  'admin.samples.generating': 'Genererer eksempler …',
  'admin.samples.run': 'Kjør eksempelgenerering',
  'admin.samples.sampleTypes': 'Eksempeltyper:',
  'admin.samples.beamReportSuffix': 'bjelkerapport',
  'admin.samples.open': 'Åpne',
  'admin.samples.steelBeamReport': 'Stålbjelkerapport',
  'admin.samples.concreteBeamReport': 'Betongbjelkerapport',
  'admin.samples.timberBeamReport': 'Trebjelkerapport',
  'admin.samples.errGenerate': 'Kunne ikke generere eksempelrapporter',
  'admin.samples.generated': 'Genererte {count} eksempelrapport(er) i {directory}.',
  'admin.samples.failed': 'Generering av eksempler mislyktes: {message}',
  'admin.samples.serverOutputDir': 'serverens utdatamappe',

  // ----- Admin regression panel -----
  'admin.regression.title': 'Regresjonstesting',
  'admin.regression.runningTests': 'Kjører tester …',
  'admin.regression.runAllTests': 'Kjør alle tester',
  'admin.regression.waitingToRun': 'Venter på kjøring …',
  'admin.regression.testSteel': 'Stålbjelke – knekking og aksial',
  'admin.regression.testConcrete': 'Betongbjelke – dynamikk',
  'admin.regression.testTimber': 'Tregulv – vibrasjon',

  // ===== Auth — common =====
  'auth.common.loading': 'Laster …',
  'auth.common.cancel': 'Avbryt',
  'auth.common.networkError': 'Nettverksfeil. Sjekk tilkoblingen og prøv igjen.',

  // ----- Auth nav actions -----
  'auth.nav.register': 'Registrer deg',
  'auth.nav.previewRegister': 'Forhåndsvis registrering',
  'auth.nav.signIn': 'Logg inn',
  'auth.nav.accountAlt': 'Konto',
  'auth.nav.myAccount': 'Min konto',
  'auth.nav.accountDashboard': 'Kontooversikt',
  'auth.nav.beamDesigner': 'Bjelkedesigner',
  'auth.nav.signOut': 'Logg ut',

  // ----- Auth route guards -----
  'auth.route.signInToPage': 'Logg inn for å få tilgang til denne siden.',
  'auth.route.noAdminPermission': 'Du har ikke tilgang til administratorområdet.',

  // ----- Forgot password -----
  'auth.forgot.errProcess': 'Kan ikke behandle forespørselen. Prøv igjen.',
  'auth.forgot.checkEmail': 'Sjekk e-posten din',
  'auth.forgot.checkEmailBefore': 'Hvis det finnes en konto for',
  'auth.forgot.checkEmailAfter': ', mottar du instruksjoner for tilbakestilling av passord snart.',
  'auth.forgot.noEmailHint': 'Fikk du ingen e-post? Sjekk søppelpostmappen eller kontakt kundestøtte.',
  'auth.forgot.backToSignIn': 'Tilbake til innlogging',
  'auth.forgot.title': 'Glemt passord?',
  'auth.forgot.subtitle': 'Skriv inn e-posten din, så sender vi deg instruksjoner for å tilbakestille passordet.',
  'auth.forgot.emailAddress': 'E-postadresse',
  'auth.forgot.sending': 'Sender …',
  'auth.forgot.sendInstructions': 'Send instruksjoner for tilbakestilling',

  // ----- Reset password -----
  'auth.reset.errMismatch': 'Passordene er ikke like.',
  'auth.reset.errMinChars': 'Passordet må være minst 6 tegn.',
  'auth.reset.errReset': 'Kan ikke tilbakestille passordet. Lenken kan ha utløpt.',
  'auth.reset.invalidLink': 'Ugyldig tilbakestillingslenke',
  'auth.reset.invalidLinkText': 'Denne lenken for tilbakestilling av passord er ugyldig eller har utløpt.',
  'auth.reset.requestNewLink': 'Be om ny tilbakestillingslenke',
  'auth.reset.done': 'Passord tilbakestilt!',
  'auth.reset.doneText': 'Passordet ditt er tilbakestilt. Videresender til innlogging …',
  'auth.reset.redirecting': 'Videresender …',
  'auth.reset.setNew': 'Angi nytt passord',
  'auth.reset.setNewSubtitle': 'Skriv inn det nye passordet ditt nedenfor.',
  'auth.reset.newPassword': 'Nytt passord',
  'auth.reset.newPasswordPlaceholder': 'Skriv inn nytt passord',
  'auth.reset.confirmPassword': 'Bekreft passord',
  'auth.reset.confirmPasswordPlaceholder': 'Bekreft nytt passord',
  'auth.reset.resetting': 'Tilbakestiller …',
  'auth.reset.resetButton': 'Tilbakestill passord',
  'auth.register.pendingTitle': 'Sjekk e-posten din',
  'auth.register.pendingBody': 'Vi har sendt deg en bekreftelseslenke. Klikk på den for å aktivere kontoen og logge inn.',
  'auth.verify.title': 'Bekreft e-postadressen',
  'auth.verify.verifying': 'Bekrefter e-postadressen …',
  'auth.verify.success': 'E-postadressen er bekreftet!',
  'auth.verify.successText': 'Du er nå logget inn.',
  'auth.verify.goToApp': 'Gå til appen',
  'auth.verify.invalidLink': 'Ugyldig bekreftelseslenke',
  'auth.verify.invalidLinkText': 'Denne bekreftelseslenken er ugyldig eller har utløpt. Registrer deg på nytt eller be om en ny lenke fra kontosiden.',

  // ----- Pending activation -----
  'auth.pending.processing': 'Behandler …',
  'auth.pending.welcome': 'Velkommen til StructuraMatrix!',
  'auth.pending.thanksBefore': 'Takk for at du registrerte deg,',
  'auth.pending.thanksAfter': '!',
  'auth.pending.statusBadge': 'Konto venter på aktivering',
  'auth.pending.reviewNote': 'Kontoen din vurderes av teamet vårt. Du får tilgang snart!',
  'auth.pending.whatsWaiting': 'Dette venter på deg:',
  'auth.pending.benefit1Label': '30 dagers gratis prøveperiode',
  'auth.pending.benefit1Rest': ' – Full tilgang til alle profesjonelle funksjoner',
  'auth.pending.benefit2Label': 'Kontinuerlig bjelkedesigner',
  'auth.pending.benefit2Rest': ' – Analyse av flere felt med Eurokode-samsvar',
  'auth.pending.benefit3Label': 'Profesjonelle rapporter',
  'auth.pending.benefit3Rest': ' – Generer beregningsdokumentasjon',
  'auth.pending.benefit4Label': 'Stål, betong og tre',
  'auth.pending.benefit4Rest': ' – Kodekontroller for flere materialer',
  'auth.pending.benefit5Label': 'Etter prøveperioden:',
  'auth.pending.benefit5Rest': ' 110 € eller 1 100 NOK per måned – avbryt når som helst',
  'auth.pending.activationTimeLabel': 'Vanlig aktiveringstid:',
  'auth.pending.activationTimeRest': ' Innen 24 timer på virkedager',
  'auth.pending.questions': 'Spørsmål? Kontakt oss på',

  // ----- Register -----
  'auth.register.benefit1Title': 'Enkel læringskurve',
  'auth.register.benefit1Desc': 'Du er allerede i gang når du bestemmer deg for å gå videre.',
  'auth.register.benefit2Title': 'Se daglig verdi',
  'auth.register.benefit2Desc': 'Se hvordan automatiske kombinasjoner, diagrammer og rapporter passer inn i prosjektene dine og sparer reelle timer.',
  'auth.register.benefit3Title': 'Utvid kompetansen din',
  'auth.register.benefit3Desc': 'Få innsikt fra avanserte materialmodeller og Eurokode-kontroller som hever de ingeniørfaglige beslutningene dine.',
  'auth.register.success': 'Registrering vellykket. Du er nå logget inn og kan begynne å bruke Bjelkedesigner.',
  'auth.register.errGeneric': 'Kan ikke fullføre registreringen akkurat nå.',
  'auth.register.heroAuthenticated': 'Du har allerede tilgang til StructuraMatrix.',
  'auth.register.heroAnonymous': 'Opprett en gratis konto for å begynne å analysere bjelker med StructuraMatrix.',
  'auth.register.badgeEngineers': 'Ingeniører',
  'auth.register.badgeSr': 'Ingeniører elsker StructuraMatrix',
  'auth.register.startTrial': 'Start din 30-dagers gratis prøveperiode',
  'auth.register.noCreditCard': 'Ingen kredittkort kreves • Full tilgang i 30 dager',
  'auth.register.alreadyRegistered': 'Du er allerede registrert',
  'auth.register.registerNow': 'Registrer nå',
  'auth.register.email': 'E-post',
  'auth.register.nameOptional': 'Navn (valgfritt)',
  'auth.register.companyOptional': 'Firmanavn (valgfritt)',
  'auth.register.password': 'Passord',
  'auth.register.viewAccount': 'Vis konto',
  'auth.register.whyTrial': 'Hvorfor registrere seg for en gratis prøveperiode',
  'auth.register.pricingTitle': 'Enkel, transparent prising',
  'auth.register.pricingSubtitle': 'Etter prøveperioden fortsetter du med et månedlig abonnement',
  'auth.register.professional': 'Profesjonell',
  'auth.register.thirtyDayTrial': '30 dagers gratis prøveperiode',
  'auth.register.perMonth': '/måned',
  'auth.register.or': 'eller',
  'auth.register.feat1': 'Ubegrenset antall bjelkeanalyser',
  'auth.register.feat2': 'Kontinuerlige bjelker med flere felt',
  'auth.register.feat3': 'Kontroller for stål, betong og tre',
  'auth.register.feat4': 'Eurokode med nasjonale tillegg',
  'auth.register.feat5': 'Profesjonelle PDF-rapporter',
  'auth.register.feat6': 'Prioritert kundestøtte',
  'auth.register.cancelAnytime': 'Avbryt når som helst • Ingen binding',
  'auth.register.pricingQuestions': 'Spørsmål om prising?',
  'auth.register.contactUs': 'Kontakt oss',

  // ----- Cooperative users (account page) -----
  'auth.coop.title': 'Samarbeidsbrukere',
  'auth.coop.addUser': 'Legg til bruker',
  'auth.coop.perAppBefore': 'Samarbeidspartnere administreres per app – de gjelder kun for dine',
  'auth.coop.perAppAfter': '-analyser. For å gi samme person tilgang i de andre appene må du legge dem til der også.',
  'auth.coop.addCoopUser': 'Legg til samarbeidsbruker',
  'auth.coop.labelUserId': 'Bruker-ID (GUID)',
  'auth.coop.labelEmail': 'E-post',
  'auth.coop.labelAuth0': 'Auth0-ID',
  'auth.coop.labelName': 'Navn',
  'auth.coop.labelRole': 'Rolle',
  'auth.coop.roleDesigner': 'Prosjekterende',
  'auth.coop.roleApproval': 'Godkjenning',
  'auth.coop.roleInfo': 'Info',
  'auth.coop.roleAll': 'Alle',
  'auth.coop.adding': 'Legger til …',
  'auth.coop.add': 'Legg til',
  'auth.coop.noUsersYet': 'Ingen samarbeidsbrukere lagt til ennå',
  'auth.coop.thName': 'Navn',
  'auth.coop.thEmail': 'E-post',
  'auth.coop.thUserId': 'Bruker-ID',
  'auth.coop.thAuth0': 'Auth0-ID',
  'auth.coop.thRole': 'Rolle',
  'auth.coop.thActions': 'Handlinger',
  'auth.coop.errLoad': 'Kunne ikke laste samarbeidsbrukere',
  'auth.coop.errAdd': 'Kunne ikke legge til samarbeidsbruker',
  'auth.coop.errDelete': 'Kunne ikke slette samarbeidsbruker',
  'auth.coop.errUserIdEmailRequired': 'Bruker-ID og e-post er påkrevd',
  'auth.coop.confirmRemove': 'Fjern denne samarbeidsbrukeren?',

  // ----- Account page -----
  'auth.account.errLogin': 'Innlogging mislyktes.',
  'auth.account.errUpdateProfile': 'Kunne ikke oppdatere profilen',
  'auth.account.profileUpdated': 'Profilen er oppdatert. Oppdaterer …',
  'auth.account.updateFailed': 'Oppdatering mislyktes',
  'auth.account.errUploadAvatar': 'Kunne ikke laste opp avatar ({status}). {text}',
  'auth.account.errUploadAvatarGeneric': 'Kunne ikke laste opp avatar.',
  'auth.account.errUploadLogo': 'Kunne ikke laste opp logo ({status}). {text}',
  'auth.account.errUploadLogoGeneric': 'Kunne ikke laste opp logo.',
  'auth.account.welcomeBack': 'Velkommen tilbake',
  'auth.account.signInSubtitle': 'Logg inn for å få tilgang til kontooversikten og administrere abonnementet ditt.',
  'auth.account.emailAddress': 'E-postadresse',
  'auth.account.password': 'Passord',
  'auth.account.passwordPlaceholder': 'Skriv inn passordet ditt',
  'auth.account.signingIn': 'Logger inn …',
  'auth.account.newToStructura': 'Ny i StructuraMatrix?',
  'auth.account.createAccountLink': 'Opprett en gratis konto',
  'auth.account.createAccountRest': ' og begynn å analysere bjelker i dag.',
  'auth.account.featAccessTools': 'Tilgang til verktøy for bjelkeanalyse',
  'auth.account.featManageSub': 'Administrer abonnementsnivået ditt',
  'auth.account.featDownloadReports': 'Last ned genererte rapporter',
  'auth.account.unavailable': 'Kontoinformasjon er for øyeblikket utilgjengelig.',
  'auth.account.manageSubtitle': 'Administrer din personlige profil, firmadetaljer og abonnementsinnstillinger',
  'auth.account.personalInfo': 'Personlig informasjon',
  'auth.account.edit': 'Rediger',
  'auth.account.avatarPreviewAlt': 'Forhåndsvisning av avatar',
  'auth.account.uploadPhoto': 'Last opp bilde',
  'auth.account.avatarUrlOptional': 'Avatar-URL (valgfritt)',
  'auth.account.yourName': 'Navnet ditt',
  'auth.account.email': 'E-post',
  'auth.account.competenceSkills': 'Kompetanse / ferdigheter',
  'auth.account.competencePlaceholder': 'Konstruksjonsteknikk, FEM, Python …',
  'auth.account.saving': 'Lagrer …',
  'auth.account.saveChanges': 'Lagre endringer',
  'auth.account.name': 'Navn',
  'auth.account.competence': 'Kompetanse',
  'auth.account.companyProfile': 'Firmaprofil',
  'auth.account.companyLogo': 'Firmalogo',
  'auth.account.companyLogoPreviewAlt': 'Forhåndsvisning av firmalogo',
  'auth.account.companyName': 'Firmanavn',
  'auth.account.portalIdInternal': 'Portal-ID (intern)',
  'auth.account.portalIdHint': 'Dette er din interne identifikator for StructuraMatrix.',
  'auth.account.contactEmail': 'Kontakt-e-post',
  'auth.account.hqLocation': 'Hovedkontor',
  'auth.account.companyPitch': 'Firmapresentasjon',
  'auth.account.companyPitchPlaceholder': 'f.eks. Vi prosjekterer sikre og bærekraftige konstruksjoner for morgendagen',
  'auth.account.sectorFocus': 'Bransjefokus',
  'auth.account.serviceKeywords': 'Tjeneste-nøkkelord',
  'auth.account.certifications': 'Sertifiseringer',
  'auth.account.role': 'Rolle',
  'auth.account.companyLogoAlt': 'Firmalogo',
  'auth.account.dtPortalId': 'Portal-ID',
  'auth.account.dtContact': 'Kontakt',
  'auth.account.dtFocus': 'Fokus',
  'auth.account.dtServices': 'Tjenester',
  'auth.account.dtSubscription': 'Abonnement',
  'auth.account.tierPlan': '{tier}-abonnement',
  'auth.account.memberSince': 'Medlem siden',
  'auth.account.renew': '{date} (forny)',

  // ===== Structura-Bits =====
  'bits.list.errLoad': 'Kunne ikke laste artikler. Prøv igjen senere.',
  'bits.list.loading': 'Laster Structura-Bits …',
  'bits.list.error': '⚠️ Feil',
  'bits.list.subtitle': 'Korte, lettleste, men informative artikler om konstruksjonsteknisk teori og praksis',
  'bits.list.noArticles': 'Ingen artikler ennå',
  'bits.list.checkBack': 'Kom tilbake snart for innsiktsfulle artikler om konstruksjonsteknikk!',
  'bits.article.errLoad': 'Artikkelen ble ikke funnet eller kunne ikke lastes.',
  'bits.article.loading': 'Laster artikkel …',
  'bits.article.notFound': '⚠️ Artikkel ikke funnet',
  'bits.article.backArrow': '← Tilbake til Structura-Bits',
  'bits.article.back': 'Tilbake til Structura-Bits',
  'bits.article.equation': 'Formel',
  'bits.article.table': 'Tabell',
  'bits.article.scrollHint': 'Rull sidelengs for å se mer',
  'bits.article.footerNote': 'Denne Structura-Bit er en del av StructuraMatrix-kunnskapsbasen.',

  // ===== Error boundary (fallback UI) =====
  'ui.errorBoundary.title': 'Noe gikk galt',
  'ui.errorBoundary.errorLabel': 'Feil:',
  'ui.errorBoundary.stackLabel': 'Sporing:',
  'ui.errorBoundary.reload': 'Last inn siden på nytt',
  // Analysis action alerts and result-banner summary (added 2026-07-04 UI audit)
  'beam.analysis.alert.axialNoSupport': '⚠️ Aksiallaster er definert, men ingen aksialfast opplagring finnes!\n\nBjelken har aksiallaster, men ingen opplagring som kan ta opp horisontal bevegelse.\n\nLegg til minst én opplagring med «Aksialfast» aktivert.',
  'beam.analysis.alert.materialLoadFailed': '⚠️ Materialegenskapene kunne ikke lastes fra databasen!\n\nKontroller Material-fanen og at et gyldig materiale er valgt.',
  'beam.analysis.alert.dynamicsNeedsAnalysis': 'Dynamikk krever en lagret analyse. Kjør analysen først, og beregn deretter dynamikk.',
  'beam.analysis.alert.materialConfigError': '⚠️ Feil i materialkonfigurasjonen:\n\n{message}',
  'beam.analysis.alert.analyzeAllFailed': '❌ Analyse av grensetilstander feilet:\n\n{message}',
  'beam.analysis.alert.timoshenkoFailed': '❌ Timoshenko-analysen feilet:\n\n{message}',
  'beam.analysis.alert.missingAnalysisId': 'Analyse-ID mangler. Kjør analysen på nytt for å få en AnalysisId.',
  'beam.analysis.alert.responseTimeout': 'Responsberegningen fikk tidsavbrudd. Forespørselen tar for lang tid — prøv med en enklere modell.',
  'beam.analysis.alert.responseFailed': 'Responsberegningen feilet: {message}',
  'beam.analysis.alert.secondOrderFailed': 'Beregning av andreordens effekter feilet: {message}',
  'beam.analysis.alert.dynamicsFailed': 'Dynamikkberegningen feilet: {message}',
  'beam.analysis.summary.allAnalyzed': 'ULS- og SLS-grensetilstander analysert, {count} lastkombinasjoner beregnet.',
  'beam.analysis.summary.timoshenkoAnalyzed': 'Timoshenko-teori: ULS- og SLS-grensetilstander analysert, {count} lastkombinasjoner.',
  'beam.analysis.summary.slenderness': 'Slankhet L/h = {ratio} (skjærdeformasjon {significance})',
  'beam.analysis.summary.shearSignificant': 'betydelig',
  'beam.analysis.summary.shearMinimal': 'ubetydelig',
  'beam.analysis.summary.shearModerate': 'moderat',
  'beam.analysis.summary.combinations': 'Kombinasjoner:',
  'beam.analysis.summary.leading': 'Dominerende {category}',
  'beam.response.notComputable': 'Kan ikke beregnes'
}
